<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:120px;" />
						<col style="" />
						<col style="width:200px;" />
						<col style="width:110px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>{{ invoice.invoice_type == 'S' ? 'Sales' : 'Return' }} Order No</th>
							<td colspan="2">
								<input type="text" v-model.trim="invoice.so_dn" class="tbl_int ssm2_int" readonly disabled />
								<template v-if="mode == 'add' && !sale_only && !return_only">
									<label class="mgr_10"><input type="radio" value="S" v-model="invoice.invoice_type" /> Sale</label>
									<label class="mgr_10" v-if="mode == 'detail' || (mode == 'add' && user.so_return)"><input type="radio" value="R" v-model="invoice.invoice_type" /> Return</label>
								</template>
								<template v-else>
									<span style="font-weight:bold;color:blue">{{ invoice.invoice_type == 'S' ? 'Sale' : 'Return' }}</span>
								</template>
								<template v-if="invoice.invoice_type == 'R' && invoice.returned_from_invoice_no">, <a href="javascript:;" @click="gotoInvoice(invoice.returned_from_invoice_no)">Issued from Invoice</a></template>
								<label v-if="invoice.invoice_type == 'S'" for="urgent_yn" style="margin-left:5px;color:red;">
									<input type="checkbox" id="urgent_yn" v-model="invoice.urgent_yn" true-value="Y" false-value="N" :disabled="!user.so_approval" /> URGENT
								</label>
								<!-- <label for="urgent_yn" style="margin-left:5px;color:red;"> <input type="checkbox" id="urgent_yn" v-model="invoice.urgent_yn" true-value="Y" false-value="N" :disabled="!modifiable" /> URGENT </label> -->
								<span style="margin-left:10px;color:blue;">
									<template v-if="invoice.org_designated && invoice.designated">
										Designated
									</template>
									<template v-else-if="!invoice.org_designated && invoice.designated">
										To Be Designated
									</template>
									<template v-else-if="invoice.org_designated && !invoice.designated">
										To Be Not Designated
									</template>
								</span>
								<span v-if="invoice.partner_blocked && invoice.invoice_type == 'S'" style="margin-left:10px;color:red;">Blocked : {{ partner.block_reason }}</span>
								<label v-if="invoice.invoice_type == 'S'" style="margin-left:10px;" for="additional_invoice"> <input type="checkbox" id="additional_invoice" v-model="additionalSO" /> Additional SO </label>
								<template v-if="profile.use_temp_flag == 'Y' && invoice.invoice_type == 'S'">
									<label style="margin-left:40px;" for="temp_flag"> <input type="checkbox" id="temp_flag" v-model="invoice.temp_flag" /> <span style="font-weight:bold;color:blue;">Ship from Georgia</span> </label>
								</template>
								<span v-if="user.company_id == 'newjigu' && invoice.invoice_type == 'S'" style="margin-left:10px;color:blue;font-weight:bold;">{{ invoice.price_confirmed ? 'Price Confirmed' : '' }}</span>
							</td>

							<th>Entry User</th>
							<td>
								<input type="text" v-model.trim="invoice.crt_name" class="tbl_int ssm2_int" readonly disabled />
								<template v-if="invoice.upd_dt"> &nbsp;Last updated : {{ invoice.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ invoice.upd_user }} </template>
								<span style="float:right;"><a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="addNew">Reset (Add New)</a></span>
							</td>
							<!-- <th>Invoice No</th> -->
						</tr>
						<tr>
							<th>Sales Date / Status</th>
							<td colspan="2">
								<CustomDatePicker v-model="invoice.so_date" :disabled="(mode == 'detail' || user.company_id == 'beautyplus') && !user.admin && !user.so_date_modifiable" style="display:inline-block;margin-right:10px;" />
								<CodeSelect className="tbl_select" :codes="saleStatusCodes" :width="60" :showDesc="true" :codeBold="true" :descBold="true" :disabled="true" v-model="invoice.status_code" style="display:inline-block;" />
								<template v-if="user.company_id == 'newjigu' && partner.notice"><input type="text" class="tbl_int lm_int" style="margin-left:10px;color:red;display:inline-block;" :value="partner.notice" readonly /> </template>
							</td>

							<template v-if="invoice.invoice_type == 'S'">
								<th>Grade</th>
								<!-- <th v-else-if="invoice.invoice_type == 'R'">Return Type</th> -->
								<td>
									<input type="text" v-model.trim="invoice.ship_to_grade" class="tbl_int sssm_int" readonly disabled />
									<currency-input type="text" v-model.trim="invoice.ship_to_credit_limit" class="tbl_int ssm_int al_right" readonly disabled style="margin-left:10px;" />
									/<currency-input type="text" v-model.trim="invoice.ship_to_total_credit_limit" class="tbl_int ssm_int al_right" readonly disabled style="margin-left:10px;" />
									<span>Credit Limit</span>
									, <currency-input type="text" v-model.trim="invoice.ar_days" :precision="0" class="tbl_int sssm_int al_right" readonly disabled /> A/R Days
								</td>
							</template>
							<template v-else>
								<th>Call Tag No</th>
								<td>
									<input type="text" v-model.trim="invoice.call_tag_dn" class="tbl_int ssm2_int" readonly disabled />
									, Call Tag / Actual Box Count :
									<currency-input type="text" v-model="invoice.call_tag_box_count" :precision="0" class="tbl_int sssm_int al_right" readonly />
									/
									<currency-input type="text" v-model="invoice.box_count" :precision="0" class="tbl_int sssm_int al_right" />
								</td>
							</template>
						</tr>
						<tr v-if="false">
							<th>Sales Date</th>
							<td colspan="2">
								<CustomDatePicker v-model="invoice.so_date" :disabled="mode == 'detail' && !user.admin && !user.so_date_modifiable" />
								<template v-if="user.company_id == 'newjigu' && partner.notice"><input type="text" class="tbl_int lm_int" style="margin-left:94px;color:red;" :value="partner.notice" readonly /> </template>
							</td>
							<th v-if="invoice.invoice_type == 'S'">Grade</th>
							<!-- <th v-else-if="invoice.invoice_type == 'R'">Return Type</th> -->
							<td v-if="invoice.invoice_type == 'S'">
								<input type="text" v-model.trim="invoice.ship_to_grade" class="tbl_int sssm_int" readonly disabled />
								<currency-input type="text" v-model.trim="invoice.ship_to_credit_limit" class="tbl_int ssm_int al_right" readonly disabled style="margin-left:10px;" />
								/<currency-input type="text" v-model.trim="invoice.ship_to_total_credit_limit" class="tbl_int ssm_int al_right" readonly disabled style="margin-left:10px;" />
								<span>Credit Limit</span>
								, <currency-input type="text" v-model.trim="invoice.ar_days" :precision="0" class="tbl_int sssm_int al_right" readonly disabled /> A/R Days
							</td>
							<!-- <td v-else-if="invoice.invoice_type == 'R'">
								<select v-model="invoice.return_type_code" class="tbl_select half_int">
									<option v-for="c in returnTypes" v-bind:value="c.code" v-bind:key="c.code">{{ c.code }} - {{ c.name }}</option>
								</select>
							</td> -->
						</tr>
						<tr>
							<th>Ship To</th>
							<td colspan="2">
								<div style="float:left;"><PartnerSelect ref="shipto" v-model="invoice.ship_to_code" :initialName="invoice.ship_to_name" :customerOnly="true" :activeOnly="true" :nameWidth="300" ph="Ship To" @set-partner="setShipTo" /></div>
								<button class="gray_bt mgr_5" style="margin-left:5px;padding: 0 15px;" @click="openMemo(partner.code)"><font :color="partner.memo ? 'red' : 'black'">Memo</font></button>
								<a v-if="invoice.ship_to_code && partnerAccessible" href="javascript:;" type="button" class="search_bt" style="padding: 0 15px;" @click="gotoPartner(invoice.ship_to_code)">Detail</a>
							</td>
							<th>Bill To</th>
							<td>
								<PartnerSelect v-model="invoice.bill_to_code" :disableInput="true" :initialName="invoice.bill_to_name" :nameWidth="240" ph="Bill To" :activeOnly="true" @set-partner="setBillTo" />
								<a v-if="invoice.invoice_type == 'S' && !invoice.payment_exists && mode == 'detail'" href="javascript:;" type="button" class="search_bt" style="padding: 0 15px;" @click="prepay()">Pre Payment</a>
								<a v-if="invoice.bill_to_code && arHistoryAccessible" href="javascript:;" type="button" class="search_bt" style="padding: 0 15px;" @click="gotoArHistory(invoice.bill_to_code, invoice.bill_to_name)">AR History</a>
								<button v-if="user.company_id == 'newjigu'" class="gray_bt mgr_5" style="margin-left:5px;padding: 0 15px;" @click="openMemo(bill_partner.code)"><font :color="bill_partner.memo ? 'red' : 'black'">Memo</font></button>
								<a v-if="user.company_id == 'newjigu' && invoice.bill_to_code && partnerAccessible" href="javascript:;" type="button" class="search_bt" style="padding: 0 15px;" @click="gotoPartner(invoice.bill_to_code)">Detail</a>
								<!-- <input type="text" class="tbl_int ssm_int" v-model="invoice.bill_to_code" placeholder="Bill To" autocomplete="off" @click="selectPartner('bill')" />
								<input type="text" class="tbl_int half_int" v-model="invoice.bill_to_name" readonly disabled /> -->
							</td>
						</tr>
						<tr>
							<th>Ship To Address</th>
							<td colspan="2">
								<input type="text" class="tbl_int near_full_int" :value="shipToAddressString()" readonly />
								<a href="javascript:;" type="button" class="gray_bt3" @click="modifyAddress()">...</a>
							</td>
							<th v-if="invoice.invoice_type == 'S'">Ship Charge</th>
							<th v-else-if="invoice.invoice_type == 'R'">Return Type</th>
							<td v-if="invoice.invoice_type == 'S'">
								<select v-model="invoice.ship_charge_code" class="tbl_select lm_int" :disabled="!user.admin && !user.ship_charge_modifiable" @change="dtscChanged()">
									<option v-for="c in shipCharges" v-bind:value="c.code" v-bind:key="c.code">{{ c.code }} - {{ c.name }}</option>
								</select>
								<span v-if="user.company_id == 'newjigu' && partner.ship_charge_code != invoice.ship_charge_code"
									>Customer's Default :
									<font color="red"
										><b>{{ partner.ship_charge_name }}</b></font
									></span
								>
								<template v-if="user.company_id == 'newjigu'">
									<input type="text" class="tbl_int ssm2_int" v-model="bill_partner.ship_info" readonly placeholder="Zone Info." />
									<span style="font-weight:bold;">YTD</span>
									<currency-input type="text" :value="bill_partner.ytd ? bill_partner.ytd : 0" :precision="2" class="tbl_int ssm_int al_right mgr_5" readonly />
									<input class="tbl_int ssm2_int" type="text" v-model="bill_partner.specialty" readonly />
									<input class="tbl_int sm_int" type="text" v-model="bill_partner.telephone" readonly />
									<input class="tbl_int sm_int" type="text" v-model="bill_partner.telephone2" readonly />
								</template>
								<template v-else-if="user.company_id == 'hairplus'">
									<input
										class="tbl_int ssm2_int"
										:style="bill_partner.bounce_count > 0 || bill_partner.return_count > 0 ? 'margin-left:50px;color:red;' : 'margin-left:50px;color:black;'"
										type="text"
										v-model="bill_partner.specialty"
										readonly
									/>
								</template>
							</td>
							<td v-else-if="invoice.invoice_type == 'R'">
								<select v-model="invoice.return_type_code" class="tbl_select half_int">
									<option v-for="c in returnTypes" v-bind:value="c.code" v-bind:key="c.code">{{ c.code }} - {{ c.name }}</option>
								</select>
							</td>
						</tr>
						<tr>
							<th v-if="invoice.invoice_type == 'S'">Pay Term</th>
							<td v-if="invoice.invoice_type == 'S'">
								<!-- <CodeSelect className="tbl_select" :codes="paymentTerms" v-model="invoice.payment_term_code" /> -->
								<select v-model="invoice.payment_term_code" class="tbl_select lm_int" :disabled="!user.admin && !user.payment_term_modifiable">
									<option v-for="c in paymentTerms" v-bind:value="c.code" v-bind:key="c.code">{{ c.code }} - {{ c.name }}</option>
								</select>
								<span v-if="user.company_id == 'newjigu' && partner.payment_term_code != invoice.payment_term_code"
									>Customer's Default :
									<font color="red"
										><b>{{ partner.payment_term_name }}</b></font
									></span
								>
								<template v-if="user.company_id == 'newjigu'">
									<input type="text" class="tbl_int ssm2_int" v-model="partner.ship_info" readonly placeholder="Zone Info." />
									<span style="font-weight:bold;">YTD</span>
									<currency-input type="text" :value="partner.ytd ? partner.ytd : 0" :precision="2" class="tbl_int ssm_int al_right mgr_5" readonly />
									<input class="tbl_int ssm2_int" type="text" v-model="partner.specialty" readonly />
									<input class="tbl_int sm_int" type="text" v-model="partner.telephone" readonly />
									<input class="tbl_int sm_int" type="text" v-model="partner.telephone2" readonly />
								</template>
							</td>
							<td></td>
							<template v-if="invoice.invoice_type == 'S'">
								<th>Delivery Type</th>
								<td>
									<!-- <CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="invoice.delivery_type_code" /> -->
									<select v-model="invoice.delivery_type_code" class="tbl_select lm_int" @change="dtscChanged()">
										<option v-for="c in deliveryTypes" v-bind:value="c.code" v-bind:key="c.code">{{ c.code }} - {{ c.name }}</option>
									</select>
									<span v-if="user.company_id == 'newjigu' && partner.delivery_type_code != invoice.delivery_type_code"
										>Customer's Default :
										<font color="red"
											><b>{{ partner.delivery_type_name }}</b></font
										></span
									>
								</td>
							</template>

							<!-- <template v-else-if="invoice.invoice_type == 'R'">
								<th>Return Type</th>
								<td>
									<select v-model="invoice.return_type_code" class="tbl_select half_int">
										<option v-for="c in returnTypes" v-bind:value="c.code" v-bind:key="c.code">{{ c.code }} - {{ c.name }}</option>
									</select>
								</td>
							</template> -->
						</tr>
						<tr>
							<th>Sales Group<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'"> / Man</template></th>
							<td>
								<div style="float:left;"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="invoice.sales_group_code" @set-code="setSalesGroup" /></div>
								<button v-if="salesGroupModifiable && mode == 'detail' && user.company_id == 'beautyplus'" class="gray_bt2" style="margin-left:2px;float:left;" @click="updateSalesGroup()">UPD</button>

								<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
									<div style="float:left;margin-left:5px;"><CodeSelect className="tbl_select" :codes="getSalesmanList()" :showDesc="true" v-model="invoice.salesman_id" /></div>

									<button v-if="salesGroupModifiable && mode == 'detail' && user.company_id == 'beautyplus'" class="gray_bt2" style="margin-left:2px;" @click="updateSalesMan()">UPD</button>
								</template>
							</td>
							<td v-if="invoice.invoice_type == 'S'">
								<label for="auto_approved" v-if="user.company_id == 'beautyplus'">
									<!-- {{ invoice.org_auto_approved }} -->
									<!-- {{ invoice.auto_approved }} -->
									<input type="checkbox" v-if="invoice.org_auto_approved" id="auto_approved" v-model="invoice.org_auto_approved" disabled />
									<font :color="invoice.auto_approved ? 'blue' : 'black'">
										<!-- {{ invoice.org_auto_approved ? invoice.auto_approved?'Pre-Approved' : invoice.auto_approved ? 'Pre-Approval Expected' : 'Not Pre-Approved by' }} -->
										<template v-if="invoice.org_auto_approved && invoice.auto_approved">
											Pre-Approved
										</template>
										<template v-else-if="!invoice.org_auto_approved && invoice.auto_approved">
											<!-- To Be Pre-Approved -->
											<label for="confirm_pre_approval"><input type="checkbox" id="confirm_pre_approval" v-model="confirm_pre_approval" />Confirm Pre-Approval</label>
										</template>
										<template v-else-if="invoice.org_auto_approved && !invoice.auto_approved">
											To Be Not Pre-Approved
										</template>
										<template v-else-if="!invoice.org_auto_approved && !invoice.auto_approved">
											Not Pre-Approved
										</template>
									</font>
								</label>
							</td>
							<td v-else></td>
							<td colspan="2" rowspan="4" style="padding-left:50px;">
								<table class="view_tbl3" border="1">
									<tbody>
										<!-- <tr>
											<th colspan="2" class="al_center remark-table">Remark</th>
										</tr> -->
										<tr>
											<th class="al_right remark-table" style="width:130px;">To Customer</th>
											<td class="remark-table"><input type="text" v-model.trim="invoice.description" class="remark_int" placeholder="Remark for Customer" /></td>
										</tr>
										<tr>
											<th class="al_right remark-table">To Accounting</th>
											<td class="remark-table"><input type="text" v-model.trim="invoice.remark" class="remark_int red_bold" placeholder="To Approval or Invoice Staff" /></td>
										</tr>
										<tr>
											<th class="al_right remark-table">To Warehouse Staff</th>
											<td class="remark-table"><input type="text" ref="remark2" v-model.trim="invoice.remark2" class="remark_int red_bold" placeholder="To Warehouse Staff" /></td>
										</tr>
										<tr>
											<th class="al_right remark-table">{{ user.company_id == 'hairplus' ? 'To Sales Remark' : 'General Remark' }}</th>
											<td class="remark-table"><input type="text" ref="general_remark" v-model.trim="invoice.general_remark" class="remark_int" :placeholder="user.company_id == 'hairplus' ? 'To Sales Remark' : 'General Remark'" /></td>
										</tr>
									</tbody>
								</table>
							</td>
						</tr>
						<tr v-if="invoice.invoice_type == 'S'">
							<th>Special Sale</th>
							<td><CodeSelect className="tbl_select" :codes="specialSales" v-model="invoice.special_sale_code" /></td>
							<td v-show="invoice.invoice_type == 'S' && !invoice.auto_approved">
								<input type="text" v-if="user.company_id == 'beautyplus'" v-model="invoice.pre_approval_reason" class="tbl_int sm_int" readonly />
								<!-- {{ invoice.pre_approval_reason }} -->
							</td>
							<!-- <th>Remark 1</th>
							<td>
								<input type="text" v-model.trim="invoice.remark" class="tbl_int red_bold" placeholder="To Approval or Invoice Staff" />
							</td> -->
						</tr>
						<tr>
							<th>Customer PO No</th>
							<td v-if="invoice.invoice_type == 'S'">
								<input type="text" class="tbl_int sm_int" v-model="invoice.customer_po_no" />
								<span v-if="user.company_id == 'minkhair'" style="float:right;font-size:12px;color:#222;font-weight:bold;margin-right:-15px;">
									Discount Rate (%)
									<currency-input type="text" v-model="dc_percent" :precision="1" :valueRange="{ min: 0, max: 100 }" class="tbl_int sssm_int al_right" />
								</span>
							</td>
							<td v-if="(mode == 'add' || invoice.status_code == 'O') && user.company_id == 'minkhair'" style="padding-left:2px;">
								<a href="javascript:;" class="gray_bt3" @click="applyToRequestPrice()">Apply to Req. Price</a>
							</td>
						</tr>
						<tr>
							<th>Qty/Amt.<span v-if="invoice.status_code == 'I'">(Shipped)</span></th>
							<td>
								<currency-input type="text" v-model="invoice.total_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
								<currency-input type="text" v-model="invoice.total_amount" class="tbl_int ssm_int al_right a" readonly />
								<template v-if="invoice.status_code == 'I'">
									(<currency-input type="text" v-model="invoice.total_shipped_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
									<currency-input type="text" v-model="invoice.total_shipped_amount" class="tbl_int ssm_int al_right c" readonly />)
								</template>

								<template v-if="invoice.invoice_type == 'S' && (mode == 'add' || invoice.status_code == 'O' || invoice.status_code == 'H')">
									<span class="mgl_15">Req. Price Total.</span>
									<currency-input type="text" v-model="total_request_amount" :precision="2" class="tbl_int ssm_int al_right d" />
								</template>

								<template v-if="invoice.invoice_type == 'S' && (mode == 'add' || invoice.status_code == 'O' || invoice.status_code == 'H' || invoice.status_code == 'A' || invoice.status_code == 'P') && user.company_id == 'newjigu'">
									<span class="mgl_15">Valid Amount</span>
									<currency-input type="text" v-model="invoice.total_valid_amount" :precision="2" class="tbl_int ssm_int al_right d" />
								</template>

								<template v-if="invoice.invoice_type == 'R'">
									, <b>Restock Fee Percent</b> : <currency-input type="text" v-model="restock_fee_percent" :precision="1" :valueRange="{ min: 0, max: 100 }" class="tbl_int sssm_int al_right" @input="calRestockFee()" /> %
								</template>
							</td>
							<!-- <template v-if="invoice.invoice_type == 'S'">
								<th>Remark 2</th>
								<td>
									<input type="text" ref="remark2" v-model.trim="invoice.remark2" class="tbl_int red_bold" placeholder="To Warehouse Staff" />
								</td>
							</template>
							<template v-else-if="invoice.invoice_type == 'R'">
								<th>Remark 1</th>
								<td>
									<input type="text" v-model.trim="invoice.remark" class="tbl_int red_bold" placeholder="To Approval or Invoice Staff" />
								</td>
							</template> -->
						</tr>
						<tr v-if="invoice.invoice_type == 'R'">
							<th>Restock Fee / Add'l C.</th>
							<td colspan="2">
								<currency-input type="text" v-model="invoice.restock_fee" :precision="2" class="tbl_int ssm_int al_right" />
								<currency-input type="text" v-model="invoice.other_charge" :precision="2" class="tbl_int ssm_int al_right" />
								, <b>Total Amount</b> : <currency-input type="text" v-model="invoice.invoice_amount" readonly :precision="2" class="tbl_int ssm_int al_right" />
							</td>
							<!-- <th>Remark 2</th>
							<td>
								<input type="text" v-model.trim="invoice.remark2" class="tbl_int red_bold" placeholder="To Warehouse Staff" />
							</td> -->
						</tr>
					</tbody>
				</table>
			</div>
			<div class="mgb_10 divide_tbl">
				<!-- 		<p class="recent_top_text">Recent <strong id="recent_invoice_count"></strong> Invoices</p> -->
				<table border="0">
					<tr>
						<td style="width:1000px;" valign="top">
							<table class="list_tbl mgb_0" id="prev_invoice" border="0">
								<thead>
									<tr>
										<th style="width:20px;">
											<span title="Master SO">{{ additionalSO ? 'M' : '' }}</span>
										</th>
										<th style="width:110px;">SO No</th>
										<th style="width:85px;">SO Date</th>
										<th style="width:40px;">Status</th>
										<th style="width:80px;">SO Amt.</th>
										<th style="width:110px;">Inv. No</th>
										<th style="width:85px;">Inv. Date</th>
										<th style="width:80px;">Inv. Amt.</th>
										<th style="width:80px;">Balance</th>
										<!-- <th>Import Items</th> -->
										<th style="width:75px;">View Items</th>
										<th>{{ user.company_id == 'hairplus' ? 'General Remark' : 'To Accounting' }}</th>
										<th>{{ user.company_id == 'newjigu' ? 'General Remark' : 'To Customer' }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="prevInvoice in prevInvoices.slice(0, 4)" v-bind:key="prevInvoice.invoice_no">
										<td v-if="additionalSO">
											<input type="radio" v-if="isMainCandidate(prevInvoice)" v-model="invoice.main_invoice_no" :value="prevInvoice.invoice_no" />
										</td>
										<td v-else>
											<span title="Slave SO">{{ prevInvoice.main_invoice_no == invoice.invoice_no ? 'S' : '' }}</span>
										</td>
										<td class="al_left">
											<a href="javascript:;" @click="selectPrevSO(prevInvoice)">{{ prevInvoice.so_dn }}</a>
										</td>
										<td class="al_left">{{ prevInvoice.so_date }}</td>
										<td class="al_center">{{ prevInvoice.status_code }}</td>
										<td class="al_right">{{ prevInvoice.total_amount | toCurrency }}</td>
										<td class="al_left">
											<a href="javascript:;" @click="selectPrevInvoice(prevInvoice)">{{ prevInvoice.invoice_dn }}</a>
										</td>
										<td class="al_left">
											<span v-if="prevInvoice.status_code == 'I'">{{ prevInvoice.invoice_date }}</span>
										</td>
										<td class="al_right">{{ prevInvoice.invoice_amount | toCurrency }}</td>
										<td class="al_right">{{ prevInvoice.balance | toCurrencyZeroNull }}</td>
										<!-- <td class="al_center"><a v-if="invoice.invoice_no != prevInvoice.invoice_no" href="javascript:;" @click="importItems(prevInvoice)">Import Items</a></td> -->
										<td class="al_center"><a v-if="invoice.invoice_no != prevInvoice.invoice_no" href="javascript:;" @click="viewPrevItems(prevInvoice)">View Items</a></td>
										<td class="al_left truncate">
											<template v-if="user.company_id == 'hairplus'">
												<span :title="prevInvoice.general_remark">{{ prevInvoice.general_remark }}</span>
											</template>
											<template v-else>
												<span :title="prevInvoice.remark">{{ prevInvoice.remark }}</span>
											</template>
										</td>
										<td class="al_left truncate">
											<template v-if="user.company_id == 'newjigu'">
												<span :title="prevInvoice.general_remark">{{ prevInvoice.general_remark }}</span>
											</template>
											<template v-else>
												<span :title="prevInvoice.description">{{ prevInvoice.description }}</span>
											</template>
										</td>
									</tr>
									<template v-if="prevInvoices.length < 4">
										<tr v-for="item in 4 - prevInvoices.length" v-bind:key="item">
											<td v-for="dummy in 11" v-bind:key="dummy">&nbsp;</td>
										</tr>
									</template>
								</tbody>
							</table>

							<div class="recent_bottom_box" style="height:45px;">
								<div class="left_bt">
									<!-- <input type="button" value="Balance" class="gray_bt" id="prev_balance_history" />  -->
									<!-- <a href="javascript:;" type="button" @click="viewAllInvoices()" class="gray_bt">All Invoices</a> -->
									<span id="recent_invoice_count" style="text-align:right;color:red;">{{ prevInvoicesCount }}</span> inv. / B. Total
									<currency-input type="text" disabled class="tbl_int al_right" style="width: 90px;font-weight:bold;color:red;" v-model="prevInvoicesBalanceSum" />
									<template v-if="mode == 'add' && this.total_current_credit > 0">
										, Sum of total amount of SO before Invoice : <currency-input type="text" disabled class="tbl_int al_right" style="width: 90px;font-weight:bold;color:red;" v-model="this.total_current_credit" />
									</template>
								</div>
								<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>
								<!-- <p class="right_text">
									<span id="recent_invoice_count" style="text-align:right;color:red;">{{ prevInvoicesCount }}</span> inv. / B. Total
									<currency-input type="text" disabled class="tbl_int al_right" style="width: 90px;" v-model="prevInvoicesBalanceSum" />
								</p> -->
							</div>
						</td>
						<td style="width:200px;padding-left:20px;" valign="top">
							<table v-if="invoice.invoice_type == 'S'" class="list_tbl mgb_0" id="post_check_list" border="0">
								<thead>
									<tr>
										<th>Post Check Date</th>
										<th>Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="check in postChecks.slice(0, 4)" v-bind:key="check.post_check_date">
										<td class="al_left">{{ check.post_check_date }}</td>
										<td class="al_right">{{ check.amount | toCurrency }}</td>
									</tr>
									<tr>
										<td class="al_right">Total Post Check Count</td>
										<td class="al_right">{{ postChecks.length }}</td>
									</tr>
								</tbody>
							</table>
							<table v-if="invoice.invoice_type == 'R'" class="list_tbl mgb_0" border="0">
								<thead>
									<tr>
										<th>Tracking No</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(tracking_no, index) in callTag.tracking_nos" v-bind:key="index">
										<td class="al_left">
											<a :href="'https://ups.com/track?loc=null&tracknum=' + tracking_no + '&requester=WT/trackdetails'" target="_blank">{{ tracking_no }}</a>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</table>
			</div>

			<div class="view_bottom_bt" v-if="user.company_id == 'newjigu'">
				<a v-if="invoice.temp_invoice_no > 0 && mode == 'add'" href="javascript:;" class="gray_bt" @click="tempSave()">Temp Save</a>
				<a v-if="invoice.temp_invoice_no > 0 && mode == 'add'" href="javascript:;" class="gray_bt mgr_10" @click="tempDelete()">Temp Delete</a>

				<a v-if="(salesGroupModifiable || user.company_id == 'newjigu') && mode == 'detail'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="updateRemarks()">Update Rmk. and Descr.</a>
				<a v-if="modifiable && savable && proceed_to_save && (!invoice.partner_blocked || invoice.invoice_type == 'R' || user.company_id != 'hairplus')" href="javascript:;" type="button" class="search_bt" @click="save(false)"
					>Save & Return</a
				>
				<a v-if="modifiable && savable && proceed_to_save && (!invoice.partner_blocked || invoice.invoice_type == 'R' || user.company_id != 'hairplus')" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)"
					>Save Only</a
				>

				<a href="javascript:;" type="button" class="gray_bt mgr_15" @click="viewHistory()">History</a>
				<a v-if="invoice.invoice_type === 'S' && mode !== 'add'" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="salesOrder()">Sales Order Print</a>
				<a v-if="invoice.invoice_type === 'R' && mode !== 'add'" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="returnSalesOrder()">Return Sales Print</a>

				<a v-if="isShowWholeTicketButtonAndUnitTicketButton" href="javascript:void(0);" type="button" class="gray_bt" @click="wholeTicketPrint()">Whole T.</a>
				<a v-if="isShowWholeTicketButtonAndUnitTicketButton" href="javascript:void(0);" type="button" class="gray_bt" @click="unitTicketModal()">Unit T.</a>

				<template v-if="invoice.status_code !== 'I' && invoice.invoice_type == 'S' && mode !== 'add'">
					<a href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="proFormaInvoicePrint()">Pro Forma Inv. Print</a>
				</template>
				<template v-if="invoice.temp_invoice_no > 0 && mode == 'add'">
					<a href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="proFormaTempInvoicePrint()">Pro Forma Inv. Print</a>
				</template>

				<template v-if="modifiable && invoice.status_code == 'O'">
					<a v-if="invoice.invoice_type == 'S' && user.so_approval && (user.company_id != 'newjigu' || invoice.price_confirmed)" href="javascript:;" type="button" class="search_bt" @click="approve(false)">Approve</a>
					<a v-else-if="invoice.invoice_type == 'S' && user.so_approval && user.company_id == 'newjigu' && !invoice.price_confirmed" href="javascript:;" type="button" class="search_bt" @click="confirmPrice(false)">Confirm Price</a>
					<a v-else-if="invoice.invoice_type == 'R' && user.so_confirm" href="javascript:;" type="button" class="search_bt" @click="confirm(true)">Confirm</a>
					<a v-if="user.so_hold" href="javascript:;" type="button" class="gray_bt" @click="hold(false)">Hold</a>
					<a v-if="canVoid || (user.user_id == invoice.crt_user && !invoice.pt_print_dt)" href="javascript:;" type="button" class="gray_bt" @click="makeVoid(false)">Void</a>
				</template>
				<template v-else-if="invoice.status_code == 'A'">
					<a v-if="user.company_id == 'minkhair' && invoice.invoice_type == 'S'" href="javascript:;" type="button" class="search_bt mgr_10" @click="makeSalesInvoice()">Make Invoice</a>
					<a v-if="pickingTicketPrintable" href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket()">Picking T.</a>
					<a v-if="modifiable && user.so_approval" href="javascript:void(0);" type="button" class="gray_bt" @click="cancelApproval(false)">Cancel Approval</a>
					<a v-if="modifiable && user.so_hold" href="javascript:;" type="button" class="gray_bt" @click="hold(false)">Hold</a>
				</template>
				<template v-else-if="modifiable && invoice.status_code == 'C'">
					<template v-if="user.so_confirm">
						<a href="javascript:;" type="button" class="search_bt" @click="makeInvoice()">Make Invoice</a>
						<a href="javascript:;" type="button" class="gray_bt" @click="cancelConfirm(true)">Cancel Confirmation</a>
					</template>
				</template>
				<template v-else-if="invoice.status_code == 'P'">
					<a v-if="user.company_id == 'minkhair' && invoice.invoice_type == 'S'" href="javascript:;" type="button" class="search_bt mgr_10" @click="makeSalesInvoice()">Make Invoice</a>
					<a v-if="pickingTicketPrintable || (user.company_id == 'newjigu' && user.approved_so_modifiable)" href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket(true)">Reprint Picking Ticket</a>
					<button class="gray_bt" @click="$refs.packingPrintHistoryModal.action()">Picking Print History</button>
					<a v-if="modifiable && canVoid" href="javascript:;" type="button" class="gray_bt" @click="makeVoid(false)">Void</a>
				</template>
				<template v-else-if="modifiable && invoice.status_code == 'H'">
					<!-- <a v-if="invoice.invoice_type == 'S' && user.so_approval" href="javascript:;" type="button" class="gray_bt" @click="approve(false)">Approve</a>
					<a v-else-if="invoice.invoice_type == 'R' && user.so_confirm" href="javascript:;" type="button" class="search_bt" @click="confirm(true)">Confirm</a> -->

					<a v-if="canUnHold" href="javascript:;" type="button" class="gray_bt" @click="unHold(false)">UnHold</a>
					<a v-if="canVoid" href="javascript:;" type="button" class="gray_bt" @click="makeVoid(false)">Void</a>
				</template>
				<template v-else-if="modifiable && invoice.status_code == 'V'">
					<a v-if="canVoid" href="javascript:;" type="button" class="gray_bt" @click="revive(false)">Revive</a>
				</template>
				<template v-else-if="invoice.status_code == 'W'">
					<a v-if="pickingTicketPrintable || (user.company_id == 'newjigu' && user.approved_so_modifiable)" href="javascript:void(0);" type="button" class="gray_bt" @click="wholeTicketPrint()">Whole T.</a>
					<a v-if="pickingTicketPrintable || (user.company_id == 'newjigu' && user.approved_so_modifiable)" href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket(true)">Reprint Picking Ticket</a>
					<button class="gray_bt" @click="$refs.packingPrintHistoryModal.action()">Picking Print History</button>
					<a v-if="modifiable && user.so_hold" href="javascript:;" type="button" class="gray_bt" @click="packedHold(false)">Hold</a>
					<a v-if="modifiable && canVoid" href="javascript:;" type="button" class="gray_bt" @click="makeVoid(false)">Void</a>
				</template>
				<template v-else-if="modifiable && invoice.status_code == 'PH'">
					<a v-if="user.so_hold" href="javascript:;" type="button" class="gray_bt" @click="packedRevive(false)">Revive</a>
				</template>
				<template v-else-if="invoice.status_code == 'I'">
					<a v-if="pickingTicketPrintable || (user.company_id == 'newjigu' && user.approved_so_modifiable)" href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket(true)">Reprint Picking Ticket</a>
					<button class="gray_bt" @click="$refs.packingPrintHistoryModal.action()">Picking Print History</button>
				</template>
				<template v-else>
					<!-- <a href="javascript:;" type="button" class="search_bt" @click="submit(false)">Save</a> -->
					<!-- <a href="javascript:;" type="button" class="search_bt" @click="submit(true)">Save Only</a> -->
				</template>
				<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Back</a>
			</div>

			<!-- New Item -->
			<!-- <div v-if="!invoice.pt_print_dt" class="left_option" style="display:inline;"> -->
			<div v-if="invoice.status_code != 'I' && invoice.status_code != 'VI'" class="left_option" style="display:inline;padding-top:10px;">
				<!-- <em style="padding-left:20px;padding-right:10px;"><b>Search Item(s) : </b></em>
				<em class="lt_text">Item Class</em> -->
				<span v-if="false" class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" :resetAfterPopup="true" @set-item-class="setItemClass" :disabled="!invoice.ship_to_code" /> </span>

				<input
					v-if="invoice.invoice_type == 'R'"
					type="text"
					:disabled="!itemEditable"
					ref="barcode_to_find"
					class="tbl_int"
					v-model.trim="barcode_to_find"
					placeholder="Barcode Scan"
					autocomplete="off"
					style="width:170px;"
					@keypress.enter="findAndPut()"
				/>
				<span class="int_type half_int">
					<!-- <input type="text" v-model.trim="keyword" placeholder="Keyword or Barcode" autofocus autocomplete="off" @keyup.enter="search()" /> -->
					<!-- <vue-bootstrap-typeahead ref="ac" v-model.trim="keyword" :maxMatches="20" :data="acClasses" :serializer="s => s.name" placeholder="Class Name, Keyword or Barcode" @hit="acSelected = $event" /> -->
					<AC ref="ac" v-show="itemEditable" :initialDisplay="keyword" :source="selectClasses" @nothingSelected="searchKeyword" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'">
					</AC>
				</span>

				<a v-if="itemEditable" href="javascript:;" class="search_bt mgr_15" @click="search()">Search and Add Item(s)</a>
				<input type="file" v-if="itemEditable" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" :disabled="!this.invoice.ship_to_code" @change="readFile" />
				<span v-if="itemEditable">* Format : Item ID / Barcode, Qty, Price, Req Price(Optional)</span>
				<!-- <a href="javascript:;" class="gray_bt" @click="reset()">Reset</a> -->
			</div>

			<div ref="div_wrapper">
				<table class="list_tbl mgb_0 add_top_line" ref="invoice_items">
					<thead>
						<tr>
							<th width="30px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
							<th width="150px;">{{ headers.class }}</th>
							<th width="70px;" v-if="user.company_id == 'he'">Rack</th>
							<th width="150px;" v-if="profile.show_item_code == 'Y'">Item Code</th>
							<th>Name</th>
							<th v-if="user.company_id != 'jc'" width="140px;">Color</th>
							<th width="70px;">Price</th>
							<th width="50px;" v-if="user.company_id == 'newjigu' && mode == 'detail' && invoice.invoice_type == 'S'">Org P.</th>
							<th width="50px;" v-if="invoice.invoice_type == 'R'">History</th>
							<th width="90px;" v-if="invoice.invoice_type == 'S'">
								Req. P.<span v-if="(mode == 'add' || invoice.status_code == 'O' || invoice.status_code == 'H') && modifiable">(<a href="javascript:;" style="margin-left:1px;" @click="clearAllRequestPrice()">CLR</a>)</span>
							</th>
							<th width="60px;">{{ invoice.invoice_type == 'R' ? 'Return' : 'Order' }}</th>
							<th width="80px;">Amount</th>
							<th width="80px;" v-if="user.company_id == 'newjigu'">Req. Amt.</th>
							<th width="60px;">{{ invoice.invoice_type == 'R' ? 'Conf.' : 'Shipped' }}</th>
							<!-- <th width="5%">Amount</th> -->
							<th width="60px;">Last($)</th>

							<template v-if="user.company_id == 'newjigu'">
								<th width="60px;">A ($)</th>
								<th width="60px;">B ($)</th>
								<th width="60px;">C ($)</th>
							</template>
							<template v-else>
								<th width="60px;">Min($)</th>
								<th width="60px;"><span v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">Pass($)</span><span v-else>S ($)</span></th>
							</template>

							<template v-if="user.company_id == 'jc'">
								<th width="60px;">WH1</th>
								<th width="60px;">WH2</th>
							</template>
							<template v-else>
								<th width="60px;">On Hand</th>
							</template>

							<th width="60px;">Available</th>
							<th width="60px;" v-if="user.company_id == 'newjigu'">On Order</th>
							<th width="60px;">On Board</th>
							<th width="90px;" v-if="user.company_id == 'newjigu'">Arr. Date</th>
							<template v-if="invoice.invoice_type == 'R'">
								<th width="40px;">D. S</th>
								<th width="40px;">D. R</th>
								<th width="40px;">D. X</th>
								<th width="40px;">R. R</th>
							</template>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in items" v-bind:key="item.invoice_item_no" v-bind:class="{ on: index == selectedIndex }" @click="selectRow(index)">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_left">
								<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
									<input type="checkbox" v-model="item.class_selected" @change="classCheckChanged(item)" />
									<b v-if="item.class_active_yn == 'N'"><font color="red">!!</font></b>
									<font :color="item.class_closed_yn == 'Y' ? 'gray' : 'black'">{{ item.class_code }}</font>
								</template>
							</td>
							<td class="al_left" v-if="user.company_id == 'he'">{{ item.rack }}</td>
							<td class="al_left" v-if="profile.show_item_code == 'Y'">{{ item.item_code }}</td>
							<td class="al_left">
								<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b>
								<a href="javascript:;" @click="selectItem(item)"
									><font :color="item.class_closed_yn == 'Y' ? 'gray' : 'black'">{{ item.name }}</font></a
								>
								<span v-if="item.pastedItem">
									(<b><font color="blue">Pasted Item</font></b
									>)</span
								>
							</td>

							<td v-if="user.company_id != 'jc'" class="al_left">
								<a href="javascript:;" @click="selectColor(item)">{{ item.color_code }}</a>
							</td>
							<td class="al_right">
								<currency-input
									type="text"
									:valueRange="{ min: getMinPrice(item) }"
									v-model="item.unit_price"
									:precision="2"
									class="r_int long_type al_right"
									:style="'color:' + getPriceColor(item) + ';'"
									:disabled="user.price_adjust_yn == 'N' || !modifiable"
									@focus="$event.target.select()"
									ref="unit_price"
									@keydown.down.prevent="goTo('unit_price', index + 1, 1)"
									@keydown.up.prevent="goTo('unit_price', index - 1, -1)"
									@keydown.right.prevent="invoice.status_code == 'O' ? goTo('req_price', index, 0) : goTo('quantity', index, 0)"
									@keydown.enter.prevent="goTo('unit_price', index + 1, 1)"
									@keydown.left.prevent="goTo('quantity', index - 1, -1)"
								/>
							</td>
							<td v-if="user.company_id == 'newjigu' && mode == 'detail' && invoice.invoice_type == 'S'" class="al_right">{{ item.org_price | toCurrency }}</td>
							<td class="al_center" v-if="invoice.invoice_type == 'R'" :title="getPrevSoPrices(item.item_id)">
								{{ getPrevSoCount(item.item_id) }}
							</td>
							<td class="al_right" v-if="invoice.invoice_type == 'S'">
								<!-- :valueRange="{ max: item.min_price }" -->
								<currency-input
									type="text"
									v-model="item.r_price"
									:precision="2"
									:valueRange="{ min: user.company_id == 'beautyplus' ? item.lock_price : 0 }"
									class="r_int long_type al_right"
									style="width:50px;"
									:disabled="(mode != 'add' && invoice.status_code != 'O' && invoice.status_code != 'H') || !modifiable"
									@focus="$event.target.select()"
									ref="req_price"
									@keydown.down.prevent="goTo('req_price', index + 1, 1)"
									@keydown.up.prevent="goTo('req_price', index - 1, -1)"
									@keydown.right.prevent="goTo('quantity', index, 0)"
									@keydown.enter.prevent="goTo('req_price', index + 1, 1)"
									@keydown.left.prevent="user.price_adjust_yn == 'Y' ? goTo('unit_price', index, 0) : goTo('quantity', index - 1, -1)"
								/>
								<a href="javascript:;" class="gray_bt2" style="margin-left:1px;" @click="applyAllClass(item)">C</a>
							</td>
							<td class="al_right">
								<!-- <money type="text" v-model="item.quantity" class="r_int long_type al_right" /> -->
								<currency-input
									type="text"
									v-model.trim="item.quantity_abs"
									:precision="0"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									:disabled="(invoice.pt_print_dt && user.icap_yn == 'N') || !modifiable"
									ref="quantity"
									@keydown.down.prevent="goTo('quantity', index + 1, 1)"
									@keydown.up.prevent="goTo('quantity', index - 1, -1)"
									@keydown.right.prevent="user.price_adjust_yn == 'Y' ? goTo('unit_price', index + 1, 1) : invoice.status_code == 'O' ? goTo('req_price', index + 1, 1) : goTo('quantity', index + 1, 1)"
									@keydown.enter.prevent="goTo('quantity', index + 1, 1)"
									@keydown.left.prevent="invoice.status_code == 'O' ? goTo('req_price', index, 0) : user.price_adjust_yn == 'Y' ? goTo('unit_price', index, 0) : goTo('quantity', index - 1, -1)"
									@input="checkOrderQuantity(item)"
								/>
							</td>
							<td class="al_right">{{ item.amount | toCurrency }}</td>
							<td class="al_right" v-if="user.company_id == 'newjigu'">{{ item.request_amount | toCurrency }}</td>
							<!-- <td class="al_right"><currency-input type="text" v-model.trim="item.shipped_quantity" :precision="0" class="r_int long_type al_right" /></td> -->
							<td class="al_right">
								<span v-if="invoice.status_code == 'I'" :style="item.shipped_quantity_abs > item.quantity_abs ? 'color:red;' : 'color:black'">{{ item.shipped_quantity_abs }}</span>
							</td>
							<!-- <td class="al_right">{{ item.shipped_amount | toCurrency }}</td> -->
							<!-- <td class="al_right">{{ item.last_price | toCurrency }}</td> -->
							<td class="al_right">{{ item.last_net_price | toCurrency }}</td>
							<template v-if="user.company_id == 'newjigu'">
								<td class="al_right">{{ item.a_price | toCurrency }}</td>
								<td class="al_right">{{ item.b_price | toCurrency }}</td>
								<td class="al_right">{{ item.c_price | toCurrency }}</td>
								<!-- <td class="al_right">{{ item.a_price | toCurrency }}</td>
						<td class="al_right">{{ item.b_price | toCurrency }}</td>
						<td class="al_right">{{ item.c_price | toCurrency }}</td> -->
							</template>
							<template v-else>
								<td class="al_right">{{ item.min_price | toCurrency }}</td>
								<td class="al_right">{{ item.s_price | toCurrency }}</td>
								<!-- <td class="al_right">{{ item.a_price | toCurrency }}</td>
						<td class="al_right">{{ item.b_price | toCurrency }}</td>
						<td class="al_right">{{ item.c_price | toCurrency }}</td> -->
							</template>

							<template v-if="user.company_id == 'jc'">
								<td class="al_right">{{ item.WH1 | commaSeparated }}</td>
								<td class="al_right">{{ item.WH2 | commaSeparated }}</td>
							</template>
							<template v-else>
								<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
							</template>

							<td class="al_right">
								<span :style="item.quantity > 0 && item.quantity > item.available_quantity ? 'color:red;font-weight:bold;' : ''">
									<a href="javascript:;" @click="selectPreemptedList(item.item_id)">
										{{ item.available_quantity | commaSeparated }}
									</a>
								</span>
							</td>
							<td class="al_right" v-if="user.company_id == 'newjigu'">
								<a href="javascript:;" @click="onOrderClick(item)">{{ item.po_quantity | commaSeparated }}</a>
							</td>
							<td class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
							<td class="al_left" v-if="user.company_id == 'newjigu'">{{ item.arrival_date }}</td>
							<template v-if="invoice.invoice_type == 'R'">
								<td class="al_right"><currency-input type="text" v-model.trim="item.return_s_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
								<td class="al_right"><currency-input type="text" v-model.trim="item.return_r_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
								<td class="al_right"><currency-input type="text" v-model.trim="item.return_x_quantity" :precision="0" class="r_int long_type al_right" :disabled="invoice.status_code == 'C'" @focus="$event.target.select()" /></td>
								<td class="al_right"><currency-input type="text" v-model.trim="item.return_rr_quantity" :precision="0" class="r_int long_type al_right" readonly /></td>
							</template>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="tbl_bottom_bt">
				<input v-if="!invoice.pt_print_dt || user.icap_yn == 'Y'" type="button" value="Delete" class="int_line_bt" @click="deleteItems()" />
				<!-- <input type="button" value="All Return" class="int_line_bt" /> -->
				<span style="padding-left:20px"># of item row:</span>
				<input type="text" readonly disabled="disabled" style="width:40px;" class="r_int long_type al_right" v-model="items.length" />

				<input v-if="true" type="button" value="Copy" class="int_line_bt" style="margin-left:5px" @click="copyItems()" />
				<!-- <input type="button" value="Cut" class="int_line_bt" style="margin-left:5px" @click="cutItems()" /> -->
				<input v-if="!invoice.pt_print_dt || user.icap_yn == 'Y'" type="button" value="Paste" class="int_line_bt" style="margin-left:5px" @click="pasteItems()" />
				<span v-if="invoice.invoice_type == 'R'" style="margin-left:40px">
					<select v-model="prev_so_period" class="tbl_select ssm_int">
						<option :value="1">1 Month</option>
						<option :value="2">2 Months</option>
						<option :value="3">3 Months</option>
						<option :value="6">6 Months</option>
						<option :value="12">1 Year</option>
						<option :value="24">2 Years</option>
						<option :value="60">5 Years</option>
						<option :value="120">10 Years</option>
					</select>
					<input type="button" value="Retrieve last sale price(s) of each item and set default price" class="int_line_bt" @click="retrieveAndSetSalesPrice()" />
				</span>
			</div>

			<div class="view_bottom_bt">
				<span style="float: left;">
					<a v-if="promotions.length > 0" href="javascript:;" class="search_bt mgr_5" @click="showPromotion()">Promotion</a>
				</span>

				<a v-if="invoice.temp_invoice_no > 0 && mode == 'add'" href="javascript:;" class="gray_bt" @click="tempSave()">Temp Save</a>
				<a v-if="invoice.temp_invoice_no > 0 && mode == 'add'" href="javascript:;" class="gray_bt mgr_10" @click="tempDelete()">Temp Delete</a>

				<a v-if="(salesGroupModifiable || user.company_id == 'newjigu') && mode == 'detail'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="updateRemarks()">Update Rmk. and Descr.</a>
				<a v-if="modifiable && savable && proceed_to_save && (!invoice.partner_blocked || invoice.invoice_type == 'R' || user.company_id != 'hairplus')" href="javascript:;" type="button" class="search_bt" @click="save(false)"
					>Save & Return</a
				>
				<a v-if="modifiable && savable && proceed_to_save && (!invoice.partner_blocked || invoice.invoice_type == 'R' || user.company_id != 'hairplus')" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)"
					>Save Only</a
				>

				<a href="javascript:;" type="button" class="gray_bt mgr_15" @click="viewHistory()">History</a>
				<a v-if="invoice.invoice_type === 'S'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="backOrder()">Back Order</a>

				<a v-if="invoice.invoice_type === 'S' && mode !== 'add'" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="salesOrder()">Sales Order Print</a>
				<a v-if="invoice.invoice_type === 'R' && mode !== 'add'" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="returnSalesOrder()">Return Sales Print</a>

				<a v-if="isShowWholeTicketButtonAndUnitTicketButton" href="javascript:void(0);" type="button" class="gray_bt" @click="wholeTicketPrint()">Whole T.</a>
				<a v-if="isShowWholeTicketButtonAndUnitTicketButton" href="javascript:void(0);" type="button" class="gray_bt" @click="unitTicketModal()">Unit T.</a>

				<template v-if="invoice.status_code !== 'I' && invoice.invoice_type == 'S' && mode !== 'add'">
					<a href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="proFormaInvoicePrint()">Pro Forma Inv. Print</a>
				</template>
				<template v-if="invoice.temp_invoice_no > 0 && mode == 'add'">
					<a href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="proFormaTempInvoicePrint()">Pro Forma Inv. Print</a>
				</template>

				<template v-if="modifiable && invoice.status_code == 'O'">
					<a v-if="invoice.invoice_type == 'S' && user.so_approval && (user.company_id != 'newjigu' || invoice.price_confirmed)" href="javascript:;" type="button" class="search_bt" @click="approve(false)">Approve</a>
					<a v-else-if="invoice.invoice_type == 'S' && user.so_approval && user.company_id == 'newjigu' && !invoice.price_confirmed" href="javascript:;" type="button" class="search_bt" @click="confirmPrice(false)">Confirm Price</a>
					<a v-else-if="invoice.invoice_type == 'R' && user.so_confirm" href="javascript:;" type="button" class="search_bt" @click="confirm(true)">Confirm</a>
					<a v-if="user.so_hold" href="javascript:;" type="button" class="gray_bt" @click="hold(false)">Hold</a>
					<a v-if="canVoid || (user.user_id == invoice.crt_user && !invoice.pt_print_dt)" href="javascript:;" type="button" class="gray_bt" @click="makeVoid(false)">Void</a>
				</template>
				<template v-else-if="invoice.status_code == 'A'">
					<a v-if="user.company_id == 'minkhair' && invoice.invoice_type == 'S'" href="javascript:;" type="button" class="search_bt mgr_10" @click="makeSalesInvoice()">Make Invoice</a>
					<a v-if="pickingTicketPrintable" href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket()">Picking T.</a>
					<a v-if="modifiable && user.so_approval" href="javascript:void(0);" type="button" class="gray_bt" @click="cancelApproval(false)">Cancel Approval</a>
					<a v-if="modifiable && user.so_hold && (user.company_id != 'beautyplus' || user.admin || user.dept_code == '2000')" href="javascript:;" type="button" class="gray_bt" @click="hold(false)">Hold</a>
				</template>
				<template v-else-if="modifiable && invoice.status_code == 'C'">
					<template v-if="user.so_confirm">
						<a href="javascript:;" type="button" class="search_bt" @click="makeInvoice()">Make Invoice</a>
						<a href="javascript:;" type="button" class="gray_bt" @click="cancelConfirm(true)">Cancel Confirmation</a>
					</template>
				</template>
				<template v-else-if="invoice.status_code == 'P'">
					<a v-if="user.company_id == 'minkhair' && invoice.invoice_type == 'S'" href="javascript:;" type="button" class="search_bt mgr_10" @click="makeSalesInvoice()">Make Invoice</a>
					<a v-if="pickingTicketPrintable || (user.company_id == 'newjigu' && user.approved_so_modifiable)" href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket(true)">Reprint Picking Ticket</a>
					<button class="gray_bt" @click="$refs.packingPrintHistoryModal.action()">Picking Print History</button>
					<a v-if="modifiable && canVoid" href="javascript:;" type="button" class="gray_bt" @click="makeVoid(false)">Void</a>
				</template>
				<template v-else-if="modifiable && invoice.status_code == 'H'">
					<!-- <a v-if="invoice.invoice_type == 'S' && user.so_approval" href="javascript:;" type="button" class="gray_bt" @click="approve(false)">Approve</a>
					<a v-else-if="invoice.invoice_type == 'R' && user.so_confirm" href="javascript:;" type="button" class="search_bt" @click="confirm(true)">Confirm</a> -->

					<a v-if="canUnHold" href="javascript:;" type="button" class="gray_bt" @click="unHold(false)">UnHold</a>
					<a v-if="canVoid" href="javascript:;" type="button" class="gray_bt" @click="makeVoid(false)">Void</a>
				</template>
				<template v-else-if="modifiable && invoice.status_code == 'V'">
					<a v-if="canVoid" href="javascript:;" type="button" class="gray_bt" @click="revive(false)">Revive</a>
				</template>
				<template v-else-if="invoice.status_code == 'W'">
					<a v-if="pickingTicketPrintable || (user.company_id == 'newjigu' && user.approved_so_modifiable)" href="javascript:void(0);" type="button" class="gray_bt" @click="wholeTicketPrint()">Whole T.</a>
					<a v-if="pickingTicketPrintable || (user.company_id == 'newjigu' && user.approved_so_modifiable)" href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket(true)">Reprint Picking Ticket</a>
					<button class="gray_bt" @click="$refs.packingPrintHistoryModal.action()">Picking Print History</button>
					<a v-if="modifiable && user.so_hold" href="javascript:;" type="button" class="gray_bt" @click="packedHold(false)">Hold</a>
					<a v-if="modifiable && canVoid" href="javascript:;" type="button" class="gray_bt" @click="makeVoid(false)">Void</a>
				</template>
				<template v-else-if="modifiable && invoice.status_code == 'PH'">
					<a v-if="user.so_hold" href="javascript:;" type="button" class="gray_bt" @click="packedRevive(false)">Revive</a>
				</template>
				<template v-else-if="invoice.status_code == 'I'">
					<a v-if="pickingTicketPrintable || (user.company_id == 'newjigu' && user.approved_so_modifiable)" href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket(true)">Reprint Picking Ticket</a>
					<button class="gray_bt" @click="$refs.packingPrintHistoryModal.action()">Picking Print History</button>
				</template>
				<template v-else>
					<!-- <a href="javascript:;" type="button" class="search_bt" @click="submit(false)">Save</a> -->
					<!-- <a href="javascript:;" type="button" class="search_bt" @click="submit(true)">Save Only</a> -->
				</template>
				<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Back</a>
			</div>
		</div>

		<!-- <div v-if="['development', 'test'].includes(env) && promotions.length > 0" ref="div_wrapper" style="width:500px;">
			Unsold Item list among top moving items
			<table class="list_tbl mgb_0 add_top_line">
				<thead>
					<tr>
						<th width="50px;"></th>
						<th>Title</th>
						<th width="80px;">Sold Status</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(p, index) in promotions" v-bind:key="p.pm_no">
						<td class="al_right">{{ index + 1 }}</td>
						<td class="al_left">{{ p.title }}</td>
						<td class="al_center">{{ p.sold ? 'Y' : 'N' }}</td>
					</tr>
				</tbody>
			</table>
		</div> -->

		<Modal @close="closeModal(true)" v-if="showModal && modalName == 'ItemSelect'" :draggable="false" style="z-index:2000">
			<template slot="title">Select Item(s)</template>
			<template slot="body">
				<!-- <ItemPopup :initialItems="searchItems" :initialItemClass="itemClass" :initialKeyword="keyword" :ship_to_code="invoice.ship_to_code" :v-on:close="closeModal()" @set-items="addItems" /> -->
				<ItemPopup
					:initialItems="searchItems"
					:initialItemClass="itemClass"
					:initialClassName="className"
					:initialKeyword="keyword"
					:invoice_type="invoice.invoice_type"
					:ship_to_code="invoice.ship_to_code"
					:focusOnAC="focusItemPopupAC"
					@forcedFocusOnAC="focusItemPopupAC = false"
					@close="closeModal(true)"
					@set-items="addItems"
				/>
				<!-- <ItemPopup :initialItems="searchItems" :initialKeyword="keyword" :ship_to_code="invoice.ship_to_code" @close="closeModal()" @set-items="addItems" /> -->
				<!-- <TestPopup :initialItems="searchItems" :initialItemClass="itemClass" :initialKeyword="keyword" :ship_to_code="invoice.ship_to_code" :v-on:close="closeModal()"></TestPopup> -->
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'History'" :draggable="false">
			<template slot="title">Sales Order History</template>
			<template slot="body">
				<!-- <div class="popup_body"> -->
				<div :style="user.company_id == 'beautyplus' || user.company_id == 'hairplus' ? 'width:1650px; height:900px;' : 'width:1350px; height:700px;'" v-on:keyup.esc="close()">
					<table class="list_tbl">
						<thead>
							<tr>
								<th width="145px;">Update Date Time</th>
								<th width="120px;">Status</th>
								<th width="90px;">Ship To</th>
								<th width="115px;">Payment Term</th>
								<th width="125px;">Ship Charge</th>
								<th width="120px;">Delivery Type</th>
								<th width="80px;">From Amt.</th>
								<th width="80px;">To Amt.</th>
								<th width="120px;">User</th>
								<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
									<th width="70px;">Picker</th>
									<th width="70px;">Pickup Start</th>
									<th width="70px;">Pickup End</th>
									<th width="70px;">Packer</th>
									<th width="70px;">Packed DT</th>
								</template>
								<th width="90px;">View Items</th>
								<th>Update Remark</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(history, index) in histories" v-bind:key="history.invoice_history_no">
								<td class="al_left">{{ history.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
								<td class="al_left">
									<span v-if="history.auto_approved && history.status_code == 'A'"><font color="blue">Pre</font>-</span>{{ history.status_code | saleStatusName }}
									<span v-if="history.designated" style="color:gray;">(D)</span>
								</td>
								<td class="al_left">{{ history.ship_to_code }}</td>
								<td class="al_left">{{ history.payment_term_name }}</td>
								<td class="al_left">{{ history.ship_charge_name }}</td>
								<td class="al_left">{{ history.delivery_type_name }}</td>
								<!-- <td class="al_right">{{ history.from_total_amount | toCurrency }}</td>
								<td class="al_right">{{ history.to_total_amount | toCurrency }}</td> -->
								<td class="al_right">{{ history.status_code == 'I' ? history.from_invoice_amount : history.from_total_amount | toCurrency }}</td>
								<td class="al_right">{{ history.status_code == 'I' ? history.to_invoice_amount : history.to_total_amount | toCurrency }}</td>
								<td class="al_left">{{ history.crt_name }}</td>
								<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.picker_id != histories[index - 1].picker_id)">
											{{ history.picker_name }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.pickup_start_dt != histories[index - 1].pickup_start_dt)">
											{{ history.pickup_start_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.pickup_end_dt != histories[index - 1].pickup_end_dt)">
											{{ history.pickup_end_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.packed_user != histories[index - 1].packed_user)">
											{{ history.packer_name }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.packed_dt != histories[index - 1].packed_dt)">
											{{ history.packed_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
								</template>
								<td class="al_left"><a href="javascript:;" @click="viewHistoryItems(history)" class="outstanading">View Items</a></td>
								<td class="al_left truncate" :title="history.update_remark">{{ history.update_remark }}</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeDoubleModal" v-if="showModal && (modalName == 'HistoryItems' || modalName == 'PrevInvoiceItems')" :draggable="false">
			<!-- <template slot="title">Sales Order History Items</template> -->
			<template slot="title">Items</template>
			<template slot="body">
				<!-- <div class="popup_body"> -->
				<div style="width:1000px; height:800px;" v-on:keyup.esc="close()">
					<table class="list_tbl">
						<thead>
							<tr>
								<th v-if="modalName == 'PrevInvoiceItems'" style="text-align:center;width:3%;"><input type="checkbox" @change="selectAllPreviousInvoiceItems()" v-model="allPreviousItemsSelected" /></th>
								<th width="10%">{{ headers.class }}</th>
								<th>Name</th>
								<th width="10%">Color</th>
								<th width="7%">Price</th>
								<th width="6%">{{ invoice.invoice_type == 'R' ? 'Return' : 'Order' }}</th>
								<th width="7%">Amount</th>
								<th width="6%">{{ invoice.invoice_type == 'R' ? 'Conf.' : 'Shipped' }}</th>
								<th width="7%">Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in popup_items" v-bind:key="item.invoice_item_no">
								<td v-if="modalName == 'PrevInvoiceItems'" class="al_center"><input type="checkbox" v-model="item.selected" /></td>
								<td class="al_left">
									<template v-if="index == 0 || (index > 0 && item.class_code != popup_items[index - 1].class_code)">
										{{ item.class_code }}
									</template>
									<!-- {{ item.class_code }} -->
								</td>

								<td class="al_left">
									<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b
									>{{ item.name }}
								</td>
								<td class="al_left">{{ item.color_code }}</td>
								<td class="al_right">{{ item.unit_price | toCurrency }}</td>
								<td class="al_right">{{ item.quantity_abs | commaSeparated }}</td>
								<td class="al_right">{{ item.amount | toCurrency }}</td>
								<td class="al_right">{{ item.shipped_quantity_abs | commaSeparated }}</td>
								<td class="al_right">{{ item.shipped_amount | toCurrency }}</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a v-if="modalName == 'PrevInvoiceItems' && user.so_imv && invoice.invoice_type == 'S'" href="javascript:;" @click="importItemsAndMakeVoid()" class="search_bt">Import and Make Void</a>
						<a v-if="modalName == 'PrevInvoiceItems'" href="javascript:;" @click="importItems()" class="search_bt">Import Only</a>
						<a href="javascript:;" @click="closeDoubleModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'PrePayment'" :draggable="false">
			<template slot="title">Pre Payment</template>
			<template slot="body">
				<ReceiptPopup :toReceiveInvoices="toReceiveInvoices" :totalReceiptAmount="pay_amount_sum" v-on:close="closeModal()" @receipt-call-back="receiptCallBack" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'PreemtedSO'" :draggable="false">
			<template slot="title">Preempted SO(s)</template>
			<template slot="body">
				<PreemptedSoPopup :invoice_no="invoice.invoice_no" :item_id="selectedItemId" v-on:close="closeModal()" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ShipToAddress'" :draggable="false">
			<template slot="title">Ship To Address</template>
			<template slot="body">
				<div style="width:600px; height:280px;">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:120px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Company Name</th>
								<td><input type="text" v-model.trim="ship_to_address.ship_to_name" class="tbl_int full_int" @focus="$event.target.select()" :readonly="shipToAddressReadOnly()" /></td>
							</tr>
							<tr>
								<th>Address</th>
								<td>
									<input type="text" v-model.trim="ship_to_address.address_detail" class="tbl_int full_int" @focus="$event.target.select()" :readonly="shipToAddressReadOnly()" />
									<input type="text" v-model.trim="ship_to_address.address_detail2" class="tbl_int full_int" @focus="$event.target.select()" placeholder="Address Line 2 (Optional)" :readonly="shipToAddressReadOnly()" />
								</td>
							</tr>
							<tr>
								<th>City / State</th>
								<td>
									<input type="text" v-model.trim="ship_to_address.address_city" class="tbl_int half_int" @focus="$event.target.select()" :readonly="shipToAddressReadOnly()" /> /
									<input type="text" v-model.trim="ship_to_address.address_state" class="tbl_int sssm_int" @focus="$event.target.select()" :readonly="shipToAddressReadOnly()" />
								</td>
							</tr>
							<tr>
								<th>Zip / Country</th>
								<td>
									<input type="text" v-model.trim="ship_to_address.address_zipcode" class="tbl_int sssm_int" @focus="$event.target.select()" :readonly="shipToAddressReadOnly()" /> /
									<input type="text" v-model.trim="ship_to_address.address_country" class="tbl_int sm_int" @focus="$event.target.select()" :readonly="shipToAddressReadOnly()" />
								</td>
							</tr>
							<tr>
								<th>Telephone</th>
								<td><input type="text" v-model.trim="ship_to_address.telephone" class="tbl_int full_int" @focus="$event.target.select()" :readonly="shipToAddressReadOnly()" /></td>
							</tr>
							<tr>
								<th><font color="red">Previous Address</font></th>
								<td>
									<select class="tbl_select full_int" v-model="selected_prev_address_index" @change="selectPrevAddress()">
										<option value="-1">Select !!!</option>
										<option v-for="(addr, index) in filtered_prev_ship_to_address_list" v-bind:value="index" v-bind:key="index"
											>{{ addr.ship_to_name }}, {{ addr.address_detail }}, {{ addr.address_detail2 }}, {{ addr.address_city }}, {{ addr.address_state }} {{ addr.address_zipcode }}</option
										>
									</select>
								</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a v-if="prev_ship_to_address_list.length > 0" href="javascript:;" style="float:left;" @click="manageShipToAddress()" class="gray_bt mgr_15">Management</a>
						<a href="javascript:;" @click="applyAddr()" class="search_bt mgr_15">Apply & Close</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>

		<ShipToAddressManagement
			v-if="showModal && modalName == 'ShipToAddressManagement'"
			:prev_ship_to_address_list="prev_ship_to_address_list"
			:partner_code="partner.code"
			:modifiable="modifiable"
			@close="closeDoubleModal()"
			@updateShipToAddr="afterUpdateShipToAddressList()"
		/>

		<Modal @close="labelModal" v-if="labelShowModal" :draggable="false">
			<template slot="title">Unit Box Label</template>
			<template slot="body">
				<table class="list_tbl">
					<thead>
						<tr>
							<th>Label</th>
							<th>Count</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="obj in locationCountList" v-bind:key="obj.name">
							<td class="al_center">{{ obj.name }}</td>
							<td class="al_right">
								<currency-input type="text" class="tbl_int full_int al_right" v-model.trim="obj.count" :precision="0" @focus="$event.target.select()" v-on:keyup.enter="unitTicketPrint()" />
							</td>
						</tr>
					</tbody>
				</table>
				<div class="popup_bottom">
					<a href="javascript:void(0);" @click="unitTicketPrint()" class="search_bt">Print</a>
					<a href="javascript:void(0);" @click="labelModal()" class="gray_bt">Close</a>
				</div>
			</template>
		</Modal>

		<packingPrintHistoryModal ref="packingPrintHistoryModal" v-if="packingPrintHistoryShow" :invoice_no="this.invoice.invoice_no" />

		<Modal @close="closeModal" v-if="showModal && (modalName == 'Memo' || modalName == 'Memo&Promotion')">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<!-- <MemoPopup :partner_code="partner.code" v-on:close="closeModal($event)" /> -->
				<MemoPopup :partner_code="partner_code_for_memo" v-on:close="closeModal($event)" />
			</template>
		</Modal>

		<Modal @close="closePromotionModal" v-if="showModal && (modalName == 'Promotion' || modalName == 'Memo&Promotion')" :draggable="false">
			<template v-slot:title>Unsold Item list among top moving items</template>
			<template v-slot:body>
				<div style="width:900px;height:600px;" v-on:keyup.esc="close()">
					<div class="half_tbl_box">
						<div class="half_tbl" style="padding-right:5px;">
							<table class="list_tbl">
								<thead>
									<tr>
										<th width="30px;"></th>
										<th>Title</th>
										<th width="80px;">Sold Status</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(p, index) in promotions_group_1" v-bind:key="p.pm_no">
										<td class="al_right">{{ index + 1 }}</td>
										<td class="al_left">{{ p.title }}</td>
										<td class="al_center">{{ p.sold ? 'YES' : 'NONE' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="half_tbl" style="padding-left:5px;">
							<table class="list_tbl">
								<thead>
									<tr>
										<th width="30px;"></th>
										<th>Title</th>
										<th width="80px;">Sold Status</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(p, index) in promotions_group_2" v-bind:key="p.pm_no">
										<td class="al_right">{{ index + 1 }}</td>
										<td class="al_left">{{ p.title }}</td>
										<td class="al_center">{{ p.sold ? 'YES' : 'NONE' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closePromotionModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'POStatus'" :draggable="false" @keydown.esc.prevent="test()">
			<template slot="title">PO Status</template>
			<template slot="body">
				<POStatusPopup :item_id="item_id" v-on:close="closeModal()" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'BackOrder'" :draggable="false" @keydown.esc.prevent="test()">
			<template slot="title">Back Order</template>
			<template slot="body">
				<BackOrderPopup :bo_ship_to_code="invoice.ship_to_code" v-on:close="closeModal()" @set-items="addItems" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick, isNumeric } from '@/utils/etc.js';
import { apiSelectPartner } from '@/api/partner/index.js';
import {
	apiCheckInactiveItemExists,
	apiDeleteTempInvoice,
	apiInsertInvoice,
	apiInsertTempInvoice,
	apiInvoicePrintData,
	apiReturnInvoicePrintData,
	apiPickingPrintDataList,
	apiPrintPickingTicket,
	apiSelectBackOrderItemList,
	apiSelectInvoice,
	apiSelectInvoiceHistoryItemList,
	apiSelectInvoiceItemList,
	apiSelectPrevInvoiceItemList,
	apiSelectInvoiceList,
	apiSelectShipToAddressHistory,
	apiSelectTempInvoice,
	apiSoIndex,
	apiSubmitInvoiceAfterBoxing,
	apiTempInvoicePrintData,
	apiUpdateInvoice,
	apiUpdateRemarks,
	apiUpdateSalesGroup,
	apiUpdateSalesMan,
	apiUpdateTempInvoice,
	apiUpdateSalesOrderPrint,
	apiUpdatePriceConfirm,
} from '@/api/sales/invoice.js';
import { apiSelectCallTag } from '@/api/sales/calltag.js';
import { apiLoadFromExcel, apiSelectItem, apiSelectItemList } from '@/api/item/master.js';
import { apiSelectNotSoldPromotionList } from '@/api/sales/promotion.js';
import { apiCheckPartnerExists } from '@/api/partner/index.js';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today } from '@/utils/date.js';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import ItemPopup from '@/components/common/ItemPopup';
import ReceiptPopup from '@/components/common/ReceiptPopup';
import PreemptedSoPopup from '@/components/common/PreemptedSoPopup';
import BackOrderPopup from './BackOrderPopup';
import Modal from '@/components/common/Modal';
import MemoPopup from '@/components/common/MemoPopup';
import _ from 'lodash';
import 'floatthead';
import { apiGetBase64ReportTemplate, apiGetReportTemplate, companyMrtUrl, objectToFormData, PrintType, Report } from '@/api/util';
import { apiArAging } from '@/api/report/report';
import AC from '@/components/common/AC';
import XLSX from 'xlsx-js-style';
import { isMobile } from 'mobile-device-detect';
import PackingPrintHistoryModal from '@/components/common/modal/sales/PackingPrintHistoryModal';
import ShipToAddressManagement from '@/components/common/ShipToAddressManagement.vue';
import POStatusPopup from '@/components/common/POStatusPopup';

export default {
	props: ['headers'],
	data: function() {
		return {
			uri: null,
			backUri: '/sales/so_main',

			paging_yn: 'Y',
			page_size: 4,
			page_no: 1,
			list_count: 0,

			mode: 'add',
			sale_only: false,
			return_only: false,
			invoice: {
				invoice_type: 'S',
				so_dn: null,

				restock_fee: 0,
				other_charge: 0,

				auto_approved: false,
				pre_approval_reason: null,

				payment_term_code: null,
				ship_charge_code: null,
				delivery_type_code: null,

				ship_to_address: {},
			},
			prev_ship_to_address_list: [],
			selected_prev_address_index: -1,
			partner: {},
			bill_partner: {},
			histories: [],

			ship_to_address: {},
			//history_items: [],

			popup_items: [],

			//acClasses: [],
			//acSelected: null,

			items: [],
			item_nos_to_delete: [],
			prevInvoices: [],
			prevInvoicesCount: 0,
			prevInvoicesBalanceSum: 0,
			postChecks: [],

			prevInvoice: {},

			callTag: {},

			shipToAddresses: [],

			additionalSO: false,
			//docs: [],

			// itemSearchOptions: {},

			businessTypes: [],
			grades: [],
			races: [],
			deliveryTypes: [],
			returnTypes: [],
			shipCharges: [],
			salesGroups: [],
			filteredSalesGroups: [],
			paymentTerms: [],
			remarks: [],
			specialSales: [],
			recipetTypes: [],
			arTypes: [],
			docTypes: [],
			saleStatusCodes: [],
			doc_type_code: null,
			doc_type_name: null,

			remark: null,

			allSelected: false,
			allPreviousItemsSelected: false,
			allShipToAddressSelected: false,

			selectedIndex: null,

			itemClass: null,
			className: null,
			barcode_to_find: null,
			keyword: '',
			searchItems: [],

			toReceiveInvoices: [],
			pay_amount_sum: null,

			current_credit: 0,
			total_current_credit: 0,
			// depts: [],
			// salesTeams: [],

			// userTypes: [
			// 	{ value: 'staff', text: 'Office' },
			// 	{ value: 'salesman', text: 'Salesman' },
			// 	{ value: 'driver', text: 'Driver' },
			// 	{ value: 'whstaff', text: 'Warehouse Staff' },
			// ],
			modalName: '',
			prevModalName: '',
			showModal: false,

			tval: 1.45,
			locationNameObjList: '',
			labelShowModal: false,
			invoicePrintData: '',
			locationList: '',

			over_90: 0,
			grand_over: 0,

			total_request_amount: 0,

			selectedItemId: null,

			temp_save_flag: false,
			packingPrintHistoryModal: false,
			focusItemPopupAC: false,

			restock_fee_percent: null,
			dc_percent: null,

			proceed_to_save: true,
			past_due_invoices: [],

			confirm_pre_approval: false,

			prev_so_period: 1, //Return SO작성 시 과거 sale 가격을 검색하기 위한 기간, 디폴트는 1개월
			prev_so_items: [],

			to_check_items: [], //중복 입력등 확인해야할 item

			partner_code_for_memo: null,

			hold_cal_total: false,

			promotions: [],
			promotions_group_1: [],
			promotions_group_2: [],
			salesmans: [],

			init_from_temp: false,
		};
	},
	computed: {
		// mainCandidateList() {
		// 	return this.prevInvoices.filter(i => i.invoice_type == 'S' && (i.status_code == 'A' || i.status_code == 'P' || i.status_code == 'W'));
		// },
		itemEditable() {
			if (this.user.admin) return true;
			else if (this.invoice.invoice_type == 'R' && (this.user.company_id == 'hairplus' || this.user.company_id == 'beautyplus') && this.user.dept_code == '3000') return false;

			return true;
		},
		partnerAccessible() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if (menus[i].path == '/partner/detail' && menus[i].view_yn == 'Y') return true;
			}
			return false;
		},
		arHistoryAccessible() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				//if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;

				if (menus[i].path == '/receipt/ar_history' && menus[i].view_yn == 'Y') return true;
			}
			return false;
		},
		salesGroupModifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		// salesmansForSearch() {
		// 	console.log(this.invoice.sales_group_code);
		// 	console.log(this.salesmans);
		// 	//console.log(this.salesmans.filter(sm => sm.sales_group_code == this.invoice.sales_group_code));
		// 	return this.salesmans.filter(sm => sm.sales_group_code == this.invoice.sales_group_code).map(sm => ({ code: sm.user_id, name: sm.user_name, sales_team_code: sm.sales_team_code }));
		// },
		modifiable() {
			//if (this.invoice.status_code == 'I' || this.invoice.status_code == 'VI') return false;
			if (this.invoice.status_code == 'I') return false;
			else if (this.invoice.status_code == 'A' && !this.user.approved_so_modifiable) return false;
			else if ((this.invoice.status_code == 'P' || this.invoice.status_code == 'W') && this.user.icap_yn == 'N') return false;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		savable() {
			if (this.user.company_id == 'beautyplus' && this.invoice.status_code == 'H') return false;

			return true;
		},
		user: function() {
			return this.$session.get('user');
		},
		env: function() {
			return process.env.NODE_ENV;
		},
		profile: function() {
			return this.$session.get('profile');
		},
		locationCountList: function() {
			let locationCountList = [];

			this.locationList.forEach(value => {
				let obj = { name: value.name, count: 0 };
				locationCountList.push(obj);
			});
			return locationCountList;
		},

		modeIsDetail() {
			return this.mode === 'detail';
		},

		invoiceTypeIsSo() {
			return this.invoice.invoice_type === 'S';
		},

		isStatusOpen() {
			return this.invoice.status_code === 'O';
		},
		isStatusApproved() {
			return this.invoice.status_code === 'A';
		},
		isStatusPacking() {
			return this.invoice.status_code === 'P';
		},
		isStatusInvoice() {
			return this.invoice.status_code === 'I';
		},
		packingPrintHistoryShow() {
			return this.modeIsDetail && this.invoiceTypeIsSo && !this.isStatusOpen && !this.isStatusApproved;
		},

		filtered_prev_ship_to_address_list() {
			return this.prev_ship_to_address_list.filter(a => a.active);
		},
		isShowWholeTicketButtonAndUnitTicketButton() {
			return this.pickingTicketPrintable && (this.isStatusApproved || this.isStatusPacking || this.isStatusInvoice);
		},
		canUnHold() {
			if (this.user.admin) return true;
			else if (this.user.company_id == 'beautyplus' && this.user.dept_code == '3500') return true;
			else return this.user.so_hold;
		},
		canVoid() {
			if (this.user.admin) return true;
			else if (this.invoice.status_code == 'O' && this.user.user_type == 'salesman') return true;
			else if (this.invoice.status_code != 'O' && this.user.user_type == 'salesman' && !this.user.so_void) return false;
			else return this.user.so_void;
		},
		pickingTicketPrintable() {
			return !!(this.user.admin || this.user.user_type === 'whstaff' || this.user.picking_ticket_print);
		},
	},
	watch: {
		invoice: {
			deep: true,
			handler: function() {
				if (!this.hold_cal_total) this.calTotal();
			},
		},
		items: {
			deep: true,
			handler: function() {
				if (!this.hold_cal_total) this.calTotal();
				// Invoice Item List Header에 의해 Item검색란이 가려지는 경우가 발생하여 조치함.
				this.$nextTick(() => {
					if (this.$refs.invoice_items) $(this.$refs.invoice_items).floatThead({ zIndex: 1, autoReflow: true });
				});
			},
		},
	},
	components: {
		PackingPrintHistoryModal,
		PartnerSelect,
		//Modal,
		CodeSelect,
		CustomDatePicker,
		ItemClassSelect,
		ItemPopup,
		Modal,
		Paging,
		ReceiptPopup,
		AC,
		MemoPopup,
		PreemptedSoPopup,
		ShipToAddressManagement,
		POStatusPopup,
		BackOrderPopup,
	},
	methods: {
		dtscChanged() {
			if (this.user.company_id != 'beautyplus') return;

			const dt = this.invoice.delivery_type_code;
			const sc = this.invoice.ship_charge_code;

			if (dt == null || sc == null) return;

			if (dt == 'T009' && sc.substring(0, 2) == 'GF') return;
			else if (dt.substring(0, 3) == 'T00' && sc.substring(0, 1) == 'U') return;
			else if (dt == 'T11' && sc.substring(0, 1) == 'F') return;
			else if (dt == 'T13' && sc.substring(0, 2) == 'DV') return;
			else if (dt == 'T14' && sc.substring(0, 2) == 'PU') return;
			else if (dt == 'T15' && sc.substring(0, 1) == 'T') return;
			else if (dt == 'T16' && sc.substring(0, 2) == 'SB') return;
			//else if (dt.substring(0, 3) != 'T00' && dt != 'T11' && dt != 'T15') return;

			this.$alertify.alert('Alert', 'Delivery Type and Ship Charge do not match.');
		},
		backOrder() {
			if (!this.invoice.ship_to_code) {
				this.$toast.error('Select Customer first.');
				return;
			}

			this.openModal('BackOrder');
		},
		onOrderClick(item) {
			this.item_id = item.item_id;
			this.modalName = 'POStatus';
			this.showModal = true;
		},
		showPromotion() {
			this.showModal = true;
			this.modalName = 'Promotion';
		},
		setSalesGroup() {
			//console.log(sg);
			this.$forceUpdate();
		},
		getSalesmanList() {
			// console.log(this.invoice.sales_group_code);
			// console.log(this.salesmans);
			return this.salesmans.filter(sm => sm.sales_group_code == this.invoice.sales_group_code).map(sm => ({ code: sm.user_id, name: sm.user_name, sales_team_code: sm.sales_team_code }));
		},
		shipToAddressReadOnly() {
			if (this.profile.ship_address_control == 'Y' && !this.user.ship_address_modifiable) return true;
			else false;
		},
		//this.$alertify.confirm('Are you sure to make invoice?', () => {
		clearAllRequestPrice() {
			if (confirm('Are you sure to clear all request price(s)?')) {
				this.items.forEach(i => {
					i.r_price = null;
				});
			}
		},
		getMinPrice(item) {
			if (item.r_confirmed || this.invoice) {
				return 0;
			} else {
				if (this.user.to_min_price_adjust_yn == 'Y') {
					if (this.user.to_lock_price_adjust_yn == 'Y') return 0;
					else return item.min_price;
				} else {
					if (item.last_net_price) return Math.min(item.min_price, item.last_net_price);
					else return item.min_price;
				}
			}
		},
		getPriceColor(item) {
			if (this.user.company_id == 'hairplus') {
				if ((this.mode == 'add' || this.invoice.status_code == 'O' || this.invoice.status_code == 'H') && ((item.min_price != null && item.unit_price != item.min_price) || (item.min_price == null && item.unit_price > 0))) return 'red';
				else if (item.unit_price < item.s_price) return 'red';
				else return '';
			} //&& item.unit_price < item.s_price) return 'red';
			else if (this.user.company_id == 'beautyplus') {
				if (item.unit_price < item.lock_price) return 'red';
				else return 'blue';
			} else if (this.user.company_id == 'newjigu' && (this.mode == 'add' || this.invoice.status_code == 'O' || this.invoice.status_code == 'H') && item.unit_price != item.b_price) return 'red';
			else return '';
		},
		confirmPrice() {
			this.$alertify.confirm('Are you sure to confirm item price(s)?', () => {
				this.confirmPriceConfirm();
			});
		},
		async confirmPriceConfirm() {
			const { data } = await apiUpdatePriceConfirm(this.invoice);
			if (data.result) {
				this.$toast.success('Saved successfully');
				this.invoice.price_confirmed = 1;
				//this.$forceUpdate();
			} else {
				this.$toast.error(data.msg);
			}
		},
		getPrevSoCount(item_id) {
			const count = this.prev_so_items.filter(i => i.item_id == item_id).length;
			if (count > 0) return count;
			else return null;
		},
		getPrevSoPrices(item_id) {
			var content = '';
			this.prev_so_items
				.filter(i => i.item_id == item_id)
				.forEach(i => {
					content += i.invoice_date + '\t' + i.unit_price.toFixed(2) + '\t' + i.shipped_quantity + '\n';
				});

			if (content) return 'Invoice Date\tPrice\tQty\n' + content;
			else return null;
		},
		async retrieveAndSetSalesPrice() {
			if (this.items.length == 0) {
				this.$toast.error('No Items');
				return;
			}
			//console.log(this.items);
			const param = {
				prev_so_period: this.prev_so_period,
				ship_to_code: this.invoice.ship_to_code,
				items: this.items,
			};
			//console.log(param);
			const { data } = await apiSelectPrevInvoiceItemList(param);
			this.prev_so_items = data.prevInvoiceItemList;

			this.items
				.filter(i => !(i.unit_price > 0))
				.forEach(i => {
					const found_item = data.prevInvoiceItemList.filter(p => p.item_id == i.item_id)[0];
					if (found_item) i.unit_price = found_item.unit_price;
				});
			//console.log(data.prevInvoiceItemList);
		},
		applyToRequestPrice() {
			if (this.dc_percent > 0) {
				this.items.forEach(i => {
					if (i.r_price > 0) {
						i.r_price = i.r_price * (100 - this.dc_percent) * 0.01;
					} else {
						i.r_price = null;
					}
				});
			}
		},
		calRestockFee() {
			if (this.restock_fee_percent > 0) {
				this.invoice.restock_fee = this.invoice.total_amount * this.restock_fee_percent * -0.01;
			}
		},
		selectPreemptedList(item_id) {
			if (this.user.preempted_so_view) {
				this.selectedItemId = item_id;
				this.modalName = 'PreemtedSO';
				this.showModal = true;
				// console.log(invoice_no, item_id);

				// const { data } = await apiSelectPreemptedInvoiceList({
				// 	invoice_no: invoice_no,
				// 	item_id: item_id,
				// });
			}
		},
		async gotoArHistory(partner_code, partner_name) {
			let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.uri, bill_to_code: partner_code, bill_to_name: partner_name } });
			window.open(routeData.href, 'herp_ar_history');

			//this.$router.push({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '1', all_date: '1' } });
			/*
			let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '1', all_date: '1' } });
			window.open(routeData.href, '_blank'); */
		},
		async gotoPartner(partner_code) {
			let routeData = this.$router.resolve({ name: 'partnerDetail', query: { backUri: this.uri, code: partner_code }, params: { mode: 'detail' } });
			window.open(routeData.href, 'herp_partner');

			//this.$router.push({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '1', all_date: '1' } });
			/*
			let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '1', all_date: '1' } });
			window.open(routeData.href, '_blank'); */
		},
		readFile(event) {
			// if (!this.invoice.ship_to_code) {
			// 	this.$toast.error('Select Customer first.');
			// 	return;
			// }
			if (event.target.files.length == 0) return;
			//console.log(event);
			//var file = this.$refs.uploadFile.files[0];
			//var vm = this;
			var file = event.target.files[0];
			//console.log(file);
			//const fileName = file.name; // declare FileReader, temp result
			const reader = new FileReader();
			//let tmpResult = {}; // if you use "this", don't use "function(e) {...}"
			reader.onload = e => {
				let data = e.target.result;
				//console.log('data', data);
				data = new Uint8Array(data); // get excel file
				let excelFile = XLSX.read(data, { type: 'array', raw: true });
				//console.log(excelFile);

				let sheetName = excelFile.SheetNames[0];
				const rows = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1, raw: false });
				// console.log(rows); // 'xlsx' -> 'xlsx-js-style'로 변경 후 test결과, rows 정상 출력됨.
				this.load(rows);

				//this.excelData = tmpResult.Sheet1;
				//console.log(this.excelData);
			};
			reader.readAsArrayBuffer(file);
		},
		async load(rows) {
			//console.log(rows);
			var excel_items = [];
			for (var i = 0; i < rows.length; i++) {
				excel_items.push({
					excel_row_no: i + 1,
					excel_item_id: rows[i][0],
					excel_quantity: rows[i][1],
					excel_price: rows[i][2],
					excel_req_price: rows[i][3],
				});
			}
			//console.log(excel_items);
			const { data } = await apiLoadFromExcel({
				for_sale: true,
				ship_to_code: this.invoice.ship_to_code,
				include_available: true,
				include_on_board: true,
				excel_json_str: JSON.stringify(excel_items),
				//excel_items: excel_items,
			});
			//console.log(data.excelItemList);
			var valid_items = data.excelItemList.filter(i => i.active_yn == 'Y' && i.class_active_yn == 'Y' && i.class_closed_yn == 'N' && !i.so_blocked);
			var invalid_items = data.excelItemList.filter(i => i.active_yn == 'N' || i.class_active_yn == 'N' || i.class_closed_yn == 'Y' || i.so_blocked);
			var not_found_items = data.excelItemList.filter(i => !i.item_id);
			//console.log('Hmmm', data);
			var msg = '';
			//if (data.excelItemList) {
			// console.log('Excel items :', data.excelItemList.length);
			// console.log('Valid items :', data.excelItemList.filter(i => i.item_id).length);
			// console.log('InValid items :', data.excelItemList.length - data.excelItemList.filter(i => i.item_id).length);
			//msg = 'Excel items : ' + data.excelItemList.length + '<br>';
			msg = 'Excel items : ' + excel_items.length + '<br>';
			//msg += 'Valid items : ' + data.excelItemList.length + '<br>';
			msg += 'Valid items : ' + valid_items.length + '<br>';
			//if (excel_items.length - data.excelItemList.length > 0) msg += 'Invalid items : ' + (excel_items.length - data.excelItemList.length) + '<br>';
			msg += 'Invalid items : ' + invalid_items.length + '<br>';
			msg += 'Not found items : ' + not_found_items.length + '<br>';
			//}//

			/* var invalid_items = [];
			excel_items.forEach(ei => {
				if (data.excelItemList.filter(i => i.item_id == ei.excel_item_id).length == 0) invalid_items.push({ excel_row_no: ei.excel_row_no, item_id: ei.excel_item_id });
			}); */

			invalid_items.forEach(i => {
				msg += '<br>Invalid item: excel row ' + i.excel_row_no + ', item id ' + i.item_id;
				if (i.active_yn == 'N' || i.class_active_yn == 'N') msg += ', Inactive';
				if (i.class_closed_yn == 'Y') msg += ', Closed';
				if (i.so_blocked) msg += ', Blocked';
			});

			not_found_items.forEach(i => {
				msg += '<br>Not found item: excel row ' + i.excel_row_no;
			});

			//user.to_lock_price_adjust_yn
			var vm = this;
			var to_add_items = [];
			//data.excelItemList.forEach(i => {
			valid_items.forEach(i => {
				// if (!i.item_id) {
				// 	msg += '<br>Invalid item: excel row ' + i.excel_row_no + ', item id ' + i.item_id;
				// } else
				if (vm.user.to_lock_price_adjust_yn == 'N' && i.excel_price < i.lock_price) {
					//console.log('lower than lock price', i.excel_row_no, i.item_id);
					msg += '<br>Lower than lock price: excel row ' + i.excel_row_no + ', item id ' + i.item_id;
				} else {
					i.quantity_abs = i.excel_quantity;
					if (vm.user.company_id == 'newjigu') {
						i.unit_price = i.b_price;
						i.r_price = i.excel_price;
					} else {
						i.unit_price = i.excel_price;
						i.r_price = i.excel_req_price;
					}
					i.last_price = i.last_net_price;
					to_add_items.push(_.cloneDeep(i));
				}
			});

			this.mergeItems(to_add_items);

			this.$alertify.alert('Excel Import', msg);
		},
		shipToAddressString() {
			var add = this.invoice.ship_to_address;
			//console.log(add);

			//if (add && Object.keys(add).length > 0) return add.ship_to_name + ', ' + add.address_detail + ', ' + add.address_city + ', ' + add.address_state + ' ' + add.address_zipcode;
			if (add && Object.keys(add).length > 0) {
				var add_string = add.ship_to_name;
				if (add.address_detail) add_string += ', ' + add.address_detail;
				if (add.address_detail2) add_string += ', ' + add.address_detail2;
				if (add.address_city) add_string += ', ' + add.address_city;
				if (add.address_state) add_string += ', ' + add.address_state;
				if (add.address_zipcode) add_string += ' ' + add.address_zipcode;

				//console.log(add_string);

				return add_string;
			} else return '';
		},
		applyAddr() {
			if (!this.ship_to_address.address_country) {
				this.$toast.error('Empty Country');
				return;
			}

			this.invoice.ship_to_address = _.cloneDeep(this.ship_to_address);
			this.closeModal();
			//this.$forceUpdate();
		},
		selectPrevAddress() {
			//console.log(this.selected_prev_address_index);

			//if (this.selected_prev_address_index >= 0) this.ship_to_address = _.cloneDeep(this.prev_ship_to_address_list[this.selected_prev_address_index]);
			if (this.selected_prev_address_index >= 0) this.ship_to_address = _.cloneDeep(this.prev_ship_to_address_list.filter(a => a.active)[this.selected_prev_address_index]);
			if (!this.ship_to_address.address_country) this.ship_to_address.address_country = 'US'; // Ship To Address Default Country로 'US' 대입.
		},
		async findAndPut() {
			if (!this.barcode_to_find) return;

			//console.log(this.invoice.call_tag_no);

			const { data } = await apiSelectItem({
				barcode: this.barcode_to_find,
				call_tag_no: this.invoice.call_tag_no,
				for_return: true,
			});
			//console.log(data);
			if (data.item) {
				var found_item = this.items.filter(i => i.item_id == data.item.item_id)[0];
				if (found_item) {
					found_item.quantity_abs++;
				} else {
					data.item.unit_price = data.item.price;
					data.item.quantity_abs = 1;
					this.items.push(data.item);
				}
				//this.item = data.item;
				//return true;;
			} else {
				this.$toast.error('Item Not Found');
			}
			this.$refs.barcode_to_find.select();
		},
		// newAddress() {
		// 	this.$alertify.promptWithTitle('New Address', '', '', (evt, value) => {
		// 		//this.reverseConfirm(value);
		// 		//console.log(value);
		// 		this.shipToAddresses.unshift(value);
		// 		this.invoice.ship_to_address = value;
		// 	});
		// },
		// editAddress() {
		// 	this.$alertify.promptWithTitle('Edit Address', '', this.invoice.ship_to_address, (evt, value) => {
		// 		//this.reverseConfirm(value);
		// 		//console.log(value);
		// 		this.shipToAddresses.unshift(value);
		// 		this.invoice.ship_to_address = value;
		// 	});
		// },
		modifyAddress() {
			if (this.invoice.ship_to_address) this.ship_to_address = _.cloneDeep(this.invoice.ship_to_address);
			else this.ship_to_address = {};

			if (!this.ship_to_address.address_country) this.ship_to_address.address_country = 'US'; // Ship To Address Default Country로 'US' 대입.

			this.modalName = 'ShipToAddress';
			this.showModal = true;
		},
		applyAllClass(item) {
			this.items
				.filter(i => i.class_code == item.class_code && i.unit_price > 0)
				.forEach(i => {
					i.r_price = item.r_price + (i.min_price - item.min_price);
				});
		},
		classCheckChanged(item) {
			this.items
				.filter(i => i.class_code == item.class_code)
				.forEach(i => {
					//i.class_selected = item.class_selected;
					i.selected = item.class_selected;
				});
		},
		isMainCandidate(inv) {
			if (
				inv.invoice_type == 'S' &&
				inv.invoice_no != this.invoice.invoice_no &&
				(inv.status_code == 'A' || inv.status_code == 'P' || inv.status_code == 'W' || inv.status_code == 'VI' || (this.user.company_id == 'newjigu' && inv.status_code == 'H'))
			)
				return true;
			else return false;
		},
		goTo(colType, index, diff) {
			this.$nextTick(() => {
				if (index < this.items.length && index >= 0) {
					if (colType == 'unit_price') this.$refs.unit_price[index].$el.select();
					else if (colType == 'req_price') this.$refs.req_price[index].$el.select();
					else if (colType == 'quantity') this.$refs.quantity[index].$el.select();

					//console.log(this.$refs.unit_price[index].$el.offsetParent.offsetTop, this.$refs.div_wrapper.offsetTop, this.$refs.unit_price[index].$el.offsetParent.offsetTop + this.$refs.div_wrapper.offsetTop);
					//console.log(this.$refs.unit_price[index].$el.offsetParent.offsetTop, this.$refs.div_wrapper.offsetTop, this.$refs.unit_price[index].$el.offsetParent.offsetTop + this.$refs.div_wrapper.offsetTop);

					//console.log(window.scrollY, window.innerHeight);

					if (diff == 1 && this.$refs.unit_price[index].$el.offsetParent.offsetTop + this.$refs.div_wrapper.offsetTop + 2 * this.$refs.unit_price[index].$el.offsetParent.scrollHeight > window.innerHeight) {
						//this.$refs.div_wrapper.scrollTop += this.$refs.unit_price[index].$el.offsetParent.scrollHeight + 1;
						window.scrollTo(window.scrollX, window.scrollY + this.$refs.unit_price[index].$el.offsetParent.scrollHeight + 1);
					} else if (diff == -1 && this.$refs.unit_price[index].$el.offsetParent.offsetTop + this.$refs.div_wrapper.offsetTop - 2 * this.$refs.unit_price[index].$el.offsetParent.scrollHeight < window.scrollY) {
						window.scrollTo(window.scrollX, this.$refs.unit_price[index].$el.offsetParent.offsetTop + this.$refs.div_wrapper.offsetTop - this.$refs.unit_price[index].$el.offsetParent.scrollHeight - 20);
					}

					//this.$refs.div_root.scrollTop = 100000;
					//console.log(this.$refs.div_root.scrollTop);
					//window.scrollTo(window.scrollX, 1000000);

					//this.$refs.unit_price[index].$el.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
					//this.$refs.div_root.scrollTop(this.$refs.unit_price[index].$el.position().top);
					this.selectedIndex = index;
				}
			});
		},
		mergeItems(items) {
			var vm = this;
			var dupl_items = [];

			items.forEach(function(item) {
				var foundItems = vm.items.filter(i => i.item_id == item.item_id);
				if ((vm.invoice.invoice_type == 'S' || vm.user.company_id == 'beautyplus' || vm.user.company_id == 'hairplus') && foundItems.length > 0) {
					foundItems[0].quantity_abs += item.quantity_abs;
					foundItems[0].valid_quantity += item.valid_quantity;
					foundItems[0].valid_amount += item.valid_amount;
					dupl_items.push(item.item_code ? item.item_code : item.name + '(' + item.color_code + ')');
					vm.to_check_items.push({ item_code: item.item_code, quantity: foundItems[0].quantity_abs });
				} else {
					vm.items.push(_.cloneDeep(item));
				}
			});

			if ((this.invoice.invoice_type == 'S' || this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') && dupl_items.length > 0) {
				if (this.user.company_id != 'beautyplus' && this.user.company_id != 'hairplus') {
					window.alert(dupl_items.join(', ') + ' Already Exist(s) in S/O List.\nPlease Check the Quantity of These Products');
				}
				this.focusItemPopupAC = true;
			}

			if (this.mode == 'add') this.temp_save_flag = true;

			this.$forceUpdate();
		},
		receiptCallBack(result) {
			//if (result) this.invoice.payment_exists = false;
			if (result) {
				this.invoice.payment_exists = false;
				//console.log('Hmmm');
				this.selectInvoice();
			}
		},
		prepay() {
			if (!this.modifiable) return;

			//console.log(this.invoice.invoice_no);
			var pay_amount = Number(prompt('Pay Amount', this.invoice.total_amount));
			if (pay_amount > 0) {
				// 	this.invoice.pay_amount = this.invoice.total_amount;
				// this.pay_amount_sum = this.invoice.total_amount;
				this.invoice.pay_amount = pay_amount;
				this.pay_amount_sum = pay_amount;

				this.toReceiveInvoices = [];
				this.toReceiveInvoices.push(this.invoice);

				this.modalName = 'PrePayment';
				this.showModal = true;
			} else {
				this.$toast.error('Invalid amount');
			}
			//console.log(pay_amount);
		},
		// async loadAcClassses(val) {
		// 	const { data } = await apiSelectItemClassList({
		// 		keyword: val,
		// 		paging_yn: 'N',
		// 		active_yn: 'Y',
		// 		closed_yn: 'N',
		// 		limit: 20,
		// 	});

		// 	this.acClasses = data.itemClassList;
		// },
		selectPrevSO(invoice) {
			this.mode = 'detail';
			this.$store.commit('setSubTitle', 'Sales Order -> Detail');
			this.invoice.invoice_no = invoice.invoice_no;
			this.selectInvoice();
			//this.init();
			//this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no }, key: this.$route.fullPath });
		},
		gotoInvoice(invoice_no) {
			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice_no } });
			window.open(routeData.href, 'herp_invoice_detail');
		},
		selectPrevInvoice(invoice) {
			// if (invoice.invoice_type == 'R') {
			// 	this.$toast.warning('Return SO will be developed later.');
			// 	return;
			// }
			//console.log(invoice);

			//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
			this.gotoInvoice(invoice.invoice_no);
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&for_sale_yn=Y&keyword=' + input;
			if (this.invoice.invoice_type == 'R') url += '&include_closed_yn=Y';

			//console.log(url);
			return url;
			//return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			this.itemClass = c.selectedObject.code;
			this.className = c.selectedObject.name;
			this.search();
			//this.searchKeyword(c.selectedObject.code);

			//console.log(str);
		},
		searchKeyword(keyword) {
			//console.log(keyword);
			this.$refs.ac.clear();
			this.keyword = keyword;
			this.search();
		},
		async viewPrevItems(prevInvoice) {
			var param = {
				invoice_no: prevInvoice.invoice_no,
			};

			if (this.invoice.invoice_type == 'R') param.invoiced_item_only = true;

			const { data } = await apiSelectInvoiceItemList(param);
			this.popup_items = data.invoiceItemList;
			this.prevInvoice = prevInvoice;

			this.modalName = 'PrevInvoiceItems';
			this.prevModalName = '';
			this.openModal(this.modalName);
		},
		checkImportValidity() {
			if (this.prevInvoice.status_code == 'V') {
				this.$toast.error('Item(s) of void SO can not be imported');
				return false;
			}

			var amount_to_add = 0;

			this.popup_items
				.filter(item => item.selected)
				.forEach(function(item) {
					if (item.amount > 0) amount_to_add += item.amount;
				});

			var credit_limit_to_check;
			if (this.user.company_id == 'newjigu') credit_limit_to_check = this.invoice.total_request_amount;
			else credit_limit_to_check = this.invoice.total_valid_amount;

			credit_limit_to_check += amount_to_add;

			//console.log(amount_to_add, credit_limit_to_check, this.invoice.ship_to_total_credit_limit);

			if (this.invoice.ship_to_total_credit_limit && credit_limit_to_check + this.total_current_credit > this.invoice.ship_to_total_credit_limit) {
				this.$toast.error('Exceeds credit limit');
				return false;
			}

			return true;
		},
		async importItemsAndMakeVoid() {
			if (!this.checkImportValidity()) return;
			//기존 invoice void로 만들기
			this.prevInvoice.status_code = 'V';
			this.prevInvoice.items = this.popup_items;
			this.prevInvoice.item_nos_to_delete = [];

			//Additional을 merge할 경우 valid qty, amount도 합쳐저야
			this.invoice.update_valid_values = true;
			//this.invoice.additional_invoice_no = this.prevInvoice.invoice_no;
			//console.log(this.prevInvoice);

			const { data } = await apiUpdateInvoice(this.prevInvoice, true);

			if (data.result) {
				this.$toast.success('Selected invoice made void');
			} else {
				this.$toast.error(data.msg);
			}

			this.importItemsConfirm();
		},
		importItems() {
			if (!this.checkImportValidity()) return;

			this.importItemsConfirm();
		},
		async importItemsConfirm() {
			var vm = this;
			//var preInvoiceItemList = data.invoiceItemList;
			//preInvoiceItemList.forEach(function(item) {
			var to_add_items = [];
			this.popup_items
				.filter(item => item.selected)
				.forEach(function(item) {
					item.invoice_item_no = null;
					if (vm.invoice.invoice_type == 'R') {
						item.quantity = item.shipped_quantity;
						item.quantity_abs = item.shipped_quantity;
						item.amount = item.shipped_amount;
					}
					item.shipped_quantity = null;
					item.shipped_quantity_abs = null;
					item.shipped_amount = null;
					item.selected = null;

					item.last_price = item.last_net_price;

					//console.log(item);

					//vm.items.push(_.cloneDeep(item));
					to_add_items.push(_.cloneDeep(item));
				});

			this.mergeItems(to_add_items);

			this.showModal = false;

			//console.log(this.prevInvoice.invoice_no);
			if (this.invoice.invoice_type == 'R' && this.prevInvoice.invoice_type == 'S' && this.prevInvoice.status_code == 'I') this.invoice.returned_from_invoice_no = this.prevInvoice.invoice_no;
			//console.log(this.items);

			//console.log(data.invoiceItemList);
		},
		async viewHistoryItems(history) {
			const { data } = await apiSelectInvoiceHistoryItemList({
				invoice_history_no: history.invoice_history_no,
			});
			//console.log(data.invoice);

			this.popup_items = data.invoiceHistoryItemList;

			//console.log(history);
			//console.log(this.history_items);
			this.prevModalName = 'History';
			this.modalName = 'HistoryItems';
		},
		manageShipToAddress() {
			this.prevModalName = 'ShipToAddress';
			this.modalName = 'ShipToAddressManagement';
		},
		selectItem(item) {
			//this.$router.push({ name: 'itemMaster', params: {}, query: { backUri: this.uri, keyword: item.item_id } });
			if (this.user.company_id == 'newjigu') {
				let routeData = this.$router.resolve({ name: 'itemInquiry', query: { backUri: this.uri, partner_code: this.invoice.ship_to_code, class_code: item.class_code } });
				window.open(routeData.href, 'herp_item_inquiry');
			} else {
				let routeData = this.$router.resolve({ name: 'itemMaster', params: {}, query: { backUri: this.uri, keyword: item.item_id } });
				window.open(routeData.href, 'herp_item');
			}
		},
		selectColor(item) {
			let routeData = this.$router.resolve({ name: 'salesGoods', query: { backUri: this.uri, class_code: item.class_code, color_code: item.color_code } });
			window.open(routeData.href, 'herp_sales_goods');
		},
		async makeInvoiceConfirm() {
			//if (this.mode == 'add') {
			this.invoice.status_code = 'I';
			this.invoice.status_changed_yn = 'Y';
			//}

			this.invoice.items = this.items;
			const { data } = await apiSubmitInvoiceAfterBoxing(this.invoice, 'add');

			if (data.result) {
				this.$toast.success('Saved successfully');

				this.$router.push(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		makeInvoice() {
			//this.$router.push({ name: 'invoiceDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, invoice_no: this.invoice.invoice_no } });
			this.$alertify.confirm('Are you sure to make invoice?', () => {
				this.invoice.total_charge = this.invoice.restock_fee + this.invoice.other_charge;
				this.invoice.invoice_amount = this.invoice.total_charge + this.invoice.total_shipped_amount;
				//console.log(this.invoice);
				this.invoice.status_code = 'I';
				this.invoice.invoice_date = today();

				this.makeInvoiceConfirm();
			});
		},
		makeSalesInvoice() {
			this.$router.push({ name: 'invoiceDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, invoice_no: this.invoice.invoice_no } });
		},
		setItemClass(itemClass) {
			//console.log('hmmm', itemClass);
			this.itemClass = itemClass.code;
			this.className = itemClass.name;
			//console.log(this.itemClass);
			//console.log('set item class');
			this.search();
		},
		async search() {
			if (!this.invoice.ship_to_code) {
				this.$toast.error('Select Customer first.');
				return;
			}

			//this.prevModalName = '';
			//console.log('tset1');
			//console.log(this.itemClass);
			this.openModal('ItemSelect');
			//this.keyword = null;
			// if (this.keyword || this.itemClass) {
			// 	const { data } = await apiSelectItemList({
			// 		class_code: this.itemClass,
			// 		keyword: this.keyword,
			// 	});

			// 	//console.log(data);
			// 	if (data.itemList.length > 0) {
			// 		this.searchItems = data.itemList;
			// 		this.openModal('ItemSelect');
			// 	} else {
			// 		this.$toast.error('No item is found');
			// 	}
			// } else {
			// 	this.$toast.error('Item Class and Keyword are Empty');
			// }
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
			this.className = null;
		},
		viewAllInvoices() {
			if (this.invoice.ship_to_code) this.$router.push('/sales/so_main?so_date_from=dummy&ship_to_code=' + this.invoice.ship_to_code);
			//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
		},
		deleteItems() {
			this.hold_cal_total = true;

			for (var i = this.items.length - 1; i >= 0; i--) {
				this.items[i].r_price_backup = this.items[i].r_price;
				if (this.items[i].selected) {
					if (this.items[i].invoice_item_no) {
						this.item_nos_to_delete.push(this.items[i].invoice_item_no);
					}
					this.items.splice(i, 1);
				}
			}

			if (this.mode == 'add') this.temp_save_flag = true;

			this.hold_cal_total = false;
			this.calTotal();

			// currency input에서 valuerange를 해 놓을 경우, 데이터가 제대로 안나와서, 일단 아래처럼 처리함
			var vm = this;
			this.$nextTick(function() {
				for (var j = 0; j < vm.items.length; j++) {
					vm.items[j].r_price = vm.items[j].r_price_backup;
				}
			});
		},
		cutItems() {
			this.copyItems();
			this.deleteItems();
		},
		copyItems() {
			//console.log('copy');
			if (this.items.filter(i => i.selected).length == 0) {
				this.$toast.error('No items selected');
				return;
			}
			if (this.items.filter(i => i.selected).length > 500) {
				this.$toast.error('Too many items');
				return;
			}

			var c_items = _.cloneDeep(this.items.filter(i => i.selected));
			c_items.forEach(function(i) {
				i.invoice_item_no = null;
			});

			if (c_items.length > 0) {
				this.$session.set('items', c_items);
				this.$toast.success('Item copied or cut');
			}
		},
		async pasteItems() {
			if (!this.invoice.ship_to_code) {
				this.$toast.error('Select Customer first.');
				return;
			}
			//console.log(this.$session.get('items'));
			var item_ids = [];
			this.$session.get('items').forEach(i => {
				item_ids.push(i.item_id);
			});

			var param = {
				item_ids: item_ids,
				for_sale: true,
				ship_to_code: this.invoice.ship_to_code,

				include_available: true,
				include_on_board: true,
			};

			const { data } = await apiSelectItemList(param);
			var pItemList = data.itemList;
			//console.log(pItemList);
			var vm = this;
			pItemList.forEach(item => {
				var foundItems = vm.$session.get('items').filter(i => i.item_id == item.item_id);
				if (foundItems.length > 0) {
					item.quantity_abs = foundItems[0].quantity_abs;
					item.r_price = foundItems[0].r_price;
				}
				//item.quantity_abs = item.quantity;
				item.unit_price = item.net_price;
				item.last_price = item.last_net_price;
				item.pastedItem = true;
				//item.selected = true;
			});
			//console.log(pItemList);
			// pItemList.forEach(function(item) {
			// 	var foundItems = vm.$session.get('items').filter(i => i.item_id == item.item_id);
			// 	if (foundItems.length > 0) item.quantity_abs = foundItems[0].quantity_abs;
			// 	//item.quantity_abs = item.quantity;
			// 	item.unit_price = item.net_price;
			// 	item.last_price = item.last_net_price;
			// });
			//console.log(data);

			//var c_items = this.$session.get('items');
			//this.items = this.items.concat(c_items);

			if (pItemList.length > 0) this.$toast.warning('Please check the price and quantity of the pasted item(s)');
			this.mergeItems(pItemList);

			//console.log(copiedItems);
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		selectAllPreviousInvoiceItems() {
			var vm = this;
			this.popup_items.forEach(function(item) {
				item.selected = vm.allPreviousItemsSelected;
			});
		},
		calTotal() {
			//console.log('calTotal Called');
			//console.log(this.items);
			var total_amount = 0;
			var total_quantity = 0;
			var total_shipped_amount = 0;
			var total_shipped_quantity = 0;
			var total_valid_amount = 0;
			var total_valid_quantity = 0;
			this.total_request_amount = 0;

			var vm = this;
			this.items.forEach(function(item) {
				if (vm.invoice.invoice_type == 'R') {
					item.quantity = item.quantity_abs * -1;
					item.shipped_quantity = item.shipped_quantity_abs * -1;

					item.return_rr_quantity = item.quantity_abs - item.return_s_quantity - item.return_x_quantity - item.return_r_quantity;
				} else {
					item.quantity = item.quantity_abs;
					item.shipped_quantity = item.shipped_quantity_abs;
				}
				item.amount = item.quantity * item.unit_price;
				item.shipped_amount = item.shipped_quantity * item.unit_price;

				if (vm.invoice.invoice_type == 'S') {
					var effective_price;

					item.valid_quantity = item.available_quantity > item.quantity ? item.quantity : item.available_quantity > 0 ? item.available_quantity : 0;

					if (vm.user.company_id == 'beautyplus' || vm.user.company_id == 'hairplus') {
						item.valid_amount = item.valid_quantity * item.unit_price;

						var effective_quantity = item.quantity < item.on_hand ? item.quantity : item.on_hand;
						effective_price = item.r_price > 0 ? item.r_price : item.min_price > 0 ? item.min_price : 0;

						//if (effective_quantity > 0) vm.total_request_amount += item.r_price > 0 ? effective_quantity * item.r_price : item.min_price > 0 ? effective_quantity * item.min_price : 0;
						if (vm.user.company_id == 'beautyplus') {
							if (effective_quantity > 0) vm.total_request_amount += effective_quantity * effective_price;
						} else {
							if (item.valid_quantity > 0) vm.total_request_amount += item.valid_quantity * effective_price;
						}
					} else {
						if (isNumeric(item.r_price)) effective_price = item.r_price;
						else effective_price = item.unit_price;

						item.valid_amount = item.valid_quantity * effective_price;

						if (item.quantity > 0 && effective_price >= 0) {
							item.request_amount = item.quantity * effective_price;
							vm.total_request_amount += item.request_amount;
							//vm.total_request_amount += item.quantity * effective_price;
						}
					}

					total_valid_quantity += item.valid_quantity;
					total_valid_amount += item.valid_amount;
					//console.log(item);
				}

				total_quantity += item.quantity;
				total_amount += item.amount;
				total_shipped_quantity += item.shipped_quantity;
				total_shipped_amount += item.shipped_amount;

				// if (!(item.quantity_abs > 0)) item.selected = true;
				// else item.selected = false;
			});

			if (this.dc_percent > 0) {
				this.invoice.dc_rate = this.dc_percent * 0.01;
				// 	var dc_amount = total_amount * this.dc_percent * 0.01;
				// 	var dc_shipped_amount = total_shipped_amount * this.dc_percent * 0.01;
				// 	total_amount = total_amount - dc_amount;
				// 	total_shipped_amount = total_shipped_amount - dc_shipped_amount;
				// 	this.invoice.dc_amount = dc_amount;
			} else {
				this.invoice.dc_rate = null;
				//this.invoice.dc_amount = null;
			}

			this.invoice.total_quantity = total_quantity;
			this.invoice.total_amount = total_amount;
			this.invoice.total_shipped_quantity = total_shipped_quantity;
			this.invoice.total_shipped_amount = total_shipped_amount;
			this.invoice.total_valid_quantity = total_valid_quantity;
			this.invoice.total_valid_amount = total_valid_amount;
			this.invoice.total_request_amount = this.total_request_amount;

			if (this.invoice.invoice_type == 'R') {
				//console.log(this.invoice.restock_fee, this.invoice.other_charge);
				if (this.invoice.status_code == 'I') this.invoice.invoice_amount = this.invoice.total_shipped_amount + this.invoice.restock_fee + this.invoice.other_charge;
				else this.invoice.invoice_amount = this.invoice.total_amount + this.invoice.restock_fee + this.invoice.other_charge;

				//console.log(this.invoice.invoice_amount);
			}

			// if (this.invoice.invoice_type == 'S' && (this.invoice.status_code == 'O' || this.invoice.status_code == 'A' || this.mode == 'add')) this.checkAutoApproval();
			if (this.invoice.invoice_type == 'S' && (this.invoice.status_code == 'O' || this.mode == 'add')) this.checkAutoApproval();

			if (this.temp_save_flag) {
				this.temp_save_flag = false;
				this.tempSave();
			}
		},
		async tempSave() {
			// const dummy = true;
			// if (dummy) return;
			//console.log('temp save');

			this.invoice.items = this.items;

			var response;
			if (this.invoice.temp_invoice_no > 0) {
				response = await apiUpdateTempInvoice(this.invoice);
			} else {
				response = await apiInsertTempInvoice(this.invoice);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Temporarily Saved');
				if (!(this.invoice.temp_invoice_no > 0)) {
					this.invoice.temp_invoice_no = data.temp_invoice_no;
					this.$forceUpdate();
					//console.log('temp saved', this.invoice.temp_invoice_no);
					//this.$router.replace(this.$route.fullPath + '&temp_invoice_no=' + this.invoice.temp_invoice_no).catch(err => err);
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		async tempDelete() {
			this.$alertify.confirm('Are you sure to delete?', () => {
				this.tempDeleteConfirm();
			});
		},
		async tempDeleteConfirm() {
			const { data } = await apiDeleteTempInvoice(this.invoice);

			if (data.result) {
				this.$toast.success('Deleted successfully');
				this.$router.push(this.backUri);
			} else {
				this.$toast.error('Failed');
			}
		},
		checkOrderQuantity(item) {
			if (!(item.quantity_abs > 0)) {
				item.selected = true;
			}
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.loadPreviouseInvoices(this.invoice.ship_to_code, pageNo);
		},
		async loadAr(partner_code) {
			if (!partner_code) return;
			//console.log('test', partner_code);
			var paramObj = { bill_to_code: partner_code };
			if (this.user.company_id == 'newjigu') paramObj.include_simple_ar_list = true;

			const param = objectToFormData(paramObj);
			const { data } = await apiArAging(param);

			if (data.value) {
				this.grand_over = data.value.grand_over;
				this.over_90 = data.value.over_90;
				// if (this.over_90 > 0) {
				// 	if (!this.invoice.partner_blocked) {
				// 		const res2 = await apiUpdatePartnerBlock({ code: partner_code, blocked: true, block_reason: 'OVER 90' });
				// 		if (res2.data.result) this.$toast.warning('This account blocked');
				// 	}
				// 	this.invoice.partner_blocked = true;
				// 	this.partner.block_reason = 'AR over 90 days exists.';
				// }
			} else {
				this.grand_over = 0;
				this.over_90 = 0;
			}

			//console.log(data.ar_list);
			this.proceed_to_save = true;
			this.past_due_invoices = [];
			if (this.user.company_id == 'newjigu') {
				this.past_due_invoices = data.ar_list.filter(a => a.past_due_date > 10 && a.balance > 0);
			}

			if (this.invoice.invoice_type == 'S' && this.past_due_invoices.length > 0) {
				var msg = 'Over 10 due days invoice exists.<br/><br/>';
				this.past_due_invoices.forEach(i => {
					msg += i.invoice_dn + ', ' + i.invoice_date + ', ' + i.balance + ', past ' + String(i.past_due_date) + ' days<br/>';
				});

				this.$alertify.alert('Alert', msg);

				//this.proceed_to_save = false;

				if (this.user.company_id == 'newjigu') {
					if (this.invoice.partner_blocked) this.proceed_to_save = false;
					else this.proceed_to_save = true; //일단 진행할 수 있게 함
				} else {
					this.proceed_to_save = false;
				}
			}

			this.$forceUpdate();
			//console.log(this.grand_over);
		},
		selectRow(index) {
			this.selectedIndex = index;
		},
		async loadNotSoldPromotionList(partner_code) {
			const { data } = await apiSelectNotSoldPromotionList({
				ship_to_code: partner_code,
			});

			this.promotions = data.promotionList;
			this.promotions_group_1 = this.promotions.filter(p => p.group_no == 1);
			this.promotions_group_2 = this.promotions.filter(p => p.group_no == 2);
		},
		async loadPreviouseInvoices(partner_code, pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('Loading Previous invoices of ', partner_code);
			const { data } = await apiSelectInvoiceList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				ship_to_code: partner_code,
				post_check_status: true,

				sort_key: 'so_date',
				sort_direction: 'DESC',
			});
			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			this.prevInvoices = data.invoiceList;
			this.prevInvoicesCount = data.invoicesSum.list_count;
			this.prevInvoicesBalanceSum = data.invoicesSum.balance_sum;
			this.postChecks = data.postCheckList;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.prevInvoicesCount);
		},
		async afterUpdateShipToAddressList() {
			await this.loadShipToAddressHistory(this.partner);
			this.closeDoubleModal();
		},
		async loadShipToAddressHistory(partner) {
			const { data } = await apiSelectShipToAddressHistory({
				ship_to_code: partner.code,
			});

			this.prev_ship_to_address_list = data.shipToAddressList;

			//console.log(this.prev_ship_to_address_list);
			//console.log(this.invoice.ship_to_address);

			// if (this.prev_ship_to_address_list.length > 0 && (this.mode == 'add' || (this.mode == 'detail' && !this.invoice.ship_to_address))) {
			// 	this.invoice.ship_to_address = _.cloneDeep(this.prev_ship_to_address_list[0]);
			// } else if (this.mode == 'add') {
			// 	this.invoice.ship_to_address = {
			// 		ship_to_name: partner.name,
			// 		address_detail: partner.address_detail,
			// 		address_city: partner.address_city,
			// 		address_state: partner.address_state,
			// 		address_zipcode: partner.address_zipcode,
			// 		address_country: partner.country,
			// 		telephone: partner.telephone,
			// 	};
			// }

			// this.shipToAddresses = data.shipToAddressList;
			// if (this.shipToAddresses.length == 0) {
			// 	this.shipToAddresses.push(partner.address_detail + ', ' + partner.address_city + ', ' + partner.address_state + ' ' + partner.address_zipcode);
			// }

			// //중복 제거
			// for (var i = this.shipToAddresses.length - 1; i > 0; i--) {
			// 	var as = this.shipToAddresses[i].split(' ');
			// 	if (as.length > 1) {
			// 		for (var j = 0; j < i - 1; j++) {
			// 			var as2 = this.shipToAddresses[j].split(' ');
			// 			if (as2.length > 1 && as[0] == as2[0] && as[as.length - 1] == as2[as2.length - 1]) {
			// 				this.shipToAddresses.splice(i, 1);
			// 				break;
			// 			}
			// 		}
			// 	}
			// 	//for (var j = 0; j < as.length; j++) console.log(as[j]);
			// }

			// this.invoice.ship_to_address = this.shipToAddresses[0];

			//console.log(this.shipToAddresses);
			//console.log(data);
		},
		setSpecialty(p) {
			if (p != null) p.specialty = 'B-' + p.bounce_count + '  R-' + p.return_count + '  A-' + p.average_paid_days;
		},
		async setShipTo(partner, skip_address) {
			//console.log(this.paymentTerms);
			//console.log(partner);
			if (partner.blocked) this.$alertify.alert('Alert', 'Blocked Account');

			this.partner = partner;
			this.setSpecialty(this.partner);

			await this.loadNotSoldPromotionList(partner.code);

			// if (this.invoice.invoice_type == 'S' && this.partner.memo && this.user.company_id != 'newjigu') {
			// 	this.openMemo(partner.code);
			// 	//if (this.promotions.length > 0)
			// }

			if (this.invoice.invoice_type == 'S' && this.user.company_id != 'newjigu') {
				if (this.partner.memo && this.promotions.length > 0) {
					this.partner_code_for_memo = partner.code;
					this.modalName = 'Memo&Promotion';
					this.showModal = true;
				} else if (this.partner.memo) {
					this.partner_code_for_memo = partner.code;
					this.modalName = 'Memo';
					this.showModal = true;
				} else if (this.promotions.length > 0) {
					this.modalName = 'Promotion';
					this.showModal = true;
				}
			}

			this.invoice.partner_blocked = partner.blocked;

			if (!skip_address) {
				this.invoice.ship_to_name = partner.name;
				this.invoice.ship_charge_code = partner.ship_charge_code;
				this.invoice.payment_term_code = partner.payment_term_code;
				this.invoice.sales_group_code = partner.sales_group_code;
				this.invoice.delivery_type_code = partner.delivery_type_code;

				this.invoice.ship_to_address = {
					ship_to_name: partner.name,
					address_detail: partner.address_detail,
					address_detail2: partner.address_detail2,
					address_city: partner.address_city,
					address_state: partner.address_state,
					address_zipcode: partner.address_zipcode,
					address_country: partner.country,
					telephone: partner.telephone,
				};
			}

			this.invoice.ship_to_grade = partner.grade_code;
			this.invoice.ship_to_credit_limit = partner.credit_limit;
			this.invoice.ship_to_total_credit_limit = partner.total_credit_limit;

			this.current_credit = partner.current_credit;
			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus')
				//BP, HP는 해당 월만 적용함
				this.total_current_credit = partner.current_credit;
			else this.total_current_credit = partner.total_current_credit;

			if (this.invoice.ship_to_total_credit_limit && this.invoice.total_amount + this.total_current_credit > this.invoice.ship_to_total_credit_limit) {
				this.$toast.error('Exceeds credit limit');
			}

			//this.loadNotSoldPromotionList(partner.code);

			this.loadPreviouseInvoices(partner.code);
			this.loadShipToAddressHistory(partner);
			//this.loadAr(partner.code);

			if (this.invoice.sales_group_code) {
				this.filteredSalesGroups = this.salesGroups.filter(sg => sg.code == this.invoice.sales_group_code);
			} else {
				this.filteredSalesGroups = this.salesGroups;
			}

			if (this.mode == 'add' && !this.invoice.salesman_id) {
				var candSalesmans = this.getSalesmanList();

				if (this.user.company_id == 'hairplus' && candSalesmans.filter(sm => sm.code == partner.salesman_id).length > 0) {
					this.invoice.salesman_id = partner.salesman_id;
				} else if (candSalesmans.length == 1) {
					this.invoice.salesman_id = candSalesmans[0].code;
				}
			}

			this.setSalesGroup();

			if (this.user.company_id == 'newjigu' || this.partner.code == this.partner.last_bill_to_code || (this.partner.last_bill_to_code == null && this.partner.bill_to_code == null)) {
				//if (!(this.invoice.temp_invoice_no > 0)) {
				if (!this.init_from_temp) {
					this.invoice.bill_to_code = this.invoice.ship_to_code;
					this.invoice.bill_to_name = this.invoice.ship_to_name;

					this.bill_partner = this.partner;
					this.setSpecialty(this.bill_partner);
				}
				this.invoice.ar_days = partner.ar_days;
				this.loadAr(partner.code);
				//} else if (!(this.invoice.temp_invoice_no > 0) && (this.partner.last_bill_to_code || this.partner.bill_to_code)) {
			} else if (!this.init_from_temp && (this.partner.last_bill_to_code || this.partner.bill_to_code)) {
				var search_bill_to_code = this.partner.last_bill_to_code ? this.partner.last_bill_to_code : this.partner.bill_to_code;

				var param = { code: search_bill_to_code };
				if (this.user.company_id == 'newjigu' || this.user.company_id == 'hairplus') param.include_specialty = true;
				var { data } = await apiSelectPartner(param);

				if (data.partner) {
					this.bill_partner = data.partner;
					this.setSpecialty(this.bill_partner);

					this.invoice.bill_to_code = search_bill_to_code;
					this.invoice.bill_to_name = data.partner.name;
					this.invoice.ar_days = data.partner.ar_days;
					await this.loadAr(this.partner.search_bill_to_code);
				}
			}

			this.$forceUpdate();

			this.$refs.ac.$el.children[0].children[1].children[0].focus();
		},
		setBillTo(partner) {
			this.bill_partner = partner;
			this.setSpecialty(this.bill_partner);

			//console.log(this.invoice.bill_to_code, partner);
			this.invoice.bill_to_code = partner.code;
			this.invoice.bill_to_name = partner.name;
			this.invoice.payment_term_code = partner.payment_term_code;

			this.invoice.ar_days = partner.ar_days;

			this.$forceUpdate();
		},
		// copy_ship_to_bill() {
		// 	// this.$nextTick(function() {
		// 	// 	console.log(this.invoice);
		// 	// 	this.invoice.bill_to_code = this.invoice.ship_to_code;
		// 	// 	this.invoice.bill_to_name = this.invoice.ship_to_name;
		// 	// 	console.log(this.invoice);
		// 	// });
		// 	//console.log(this.invoice);
		// 	this.invoice.bill_to_code = this.invoice.ship_to_code;
		// 	this.invoice.bill_to_name = this.invoice.ship_to_name;
		// 	//console.log(this.invoice);
		// 	this.$forceUpdate();
		// },
		setRemark(code) {
			//console.log(test);
			if (code) this.invoice.remark = code.name;
		},
		updateRemark() {
			this.remark = null;
		},
		async selectInvoice() {
			var param = {
				invoice_no: this.invoice.invoice_no,
				include_history: true,
				include_partner: true,

				include_ship_to_address: true,
			};
			if (this.user.company_id == 'newjigu' || this.user.company_id == 'hairplus') param.include_specialty = true;

			const { data } = await apiSelectInvoice(param);

			//console.log(data.invoice);
			//console.log(data.invoice.auto_approved);
			this.invoice = data.invoice;
			this.invoice.org_status_code = this.invoice.status_code;
			//console.log(data.invoice.auto_approved, data.invoice.org_auto_approved, this.invoice.auto_approved);
			this.invoice.org_auto_approved = this.invoice.auto_approved;
			//console.log(data.invoice.auto_approved, data.invoice.org_auto_approved, this.invoice.auto_approved);
			this.invoice.org_designated = this.invoice.designated;
			this.invoice.ship_to_address = data.shipToAddress;
			//console.log(this.invoice.ship_to_address);
			this.partner = data.partner;
			this.setSpecialty(this.partner);
			this.bill_partner = data.bill_partner;
			this.setSpecialty(this.bill_partner);

			this.dc_percent = this.invoice.dc_rate * 100;
			//if (this.partner.memo) this.openModal('Memo');
			// refrence udpate를 위해서 먼저 비운다음, 다시 할당함
			this.items = [];
			await this.$nextTick();
			this.items = data.invoiceItemList;

			if (this.user.company_id == 'jc') {
				this.items.forEach(function(item) {
					/* jc의 경우 warehouse별 on_hand 처리를 위해, locatino code가 고정된 걸로 가정함 */
					item.WH1 = null;
					item.WH2 = null;
					item.WH_NULL = null;
					if (item.wh_on_hand_str) {
						const wh_on_hands = item.wh_on_hand_str.split('||');
						wh_on_hands.forEach(woh => {
							const ohs = woh.split('|');

							if (ohs.length == 2) {
								if (ohs[0] == 'WH1') {
									item.WH1 = Number(ohs[1]);
								} else if (ohs[0] == 'WH2') {
									item.WH2 = Number(ohs[1]);
								} else if (ohs[0] == 'WH_NULL') {
									item.WH_NULL = Number(ohs[1]);
								}
							}
						});
					}
				});
			}
			this.histories = data.invoiceHistoryList;
			//console.log(this.histories);
			if (this.invoice.invoice_type == 'R') {
				if (data.calltag) {
					this.callTag = data.callTag;
					//console.log(this.callTag);
					if (this.callTag.tracking_nos) {
						this.callTag.tracking_nos = this.callTag.tracking_nos.split('|');
					} else {
						this.callTag.tracking_nos = [];
					}
				} else {
					this.callTag = {};
				}
			}
			//console.log(this.callTag);

			//console.log('*' + this.invoice.ship_to_code + '*');
			if (this.invoice.ship_to_code != null) {
				this.loadNotSoldPromotionList(this.invoice.ship_to_code);

				this.loadPreviouseInvoices(this.invoice.ship_to_code, this.page_no);
				this.loadShipToAddressHistory(data.partner);
			}

			if (this.invoice.bill_to_code != null) {
				this.loadAr(this.invoice.bill_to_code);
			}

			if (this.invoice.sales_group_code) {
				this.filteredSalesGroups = this.salesGroups.filter(sg => sg.code == this.invoice.sales_group_code);
			} else {
				return (this.filteredSalesGroups = this.salesGroups);
			}

			this.additionalSO = this.invoice.main_invoice_no ? true : false;

			this.to_check_items = [];
			this.item_nos_to_delete = [];
			//this.loadPreviouseInvoices(this.invoice.ship_to_code);

			//console.log(this.invoice);
			//console.log(this.items);
		},
		async checkInactiveItemExists() {
			if (this.invoice.invoice_type == 'R') return false;
			//if (this.invoice.invoice_type == 'R' || this.mode == 'detail') return false;

			const { data } = await apiCheckInactiveItemExists({ items: this.items });
			if (data.result) {
				this.$toast.error('Inactive item(s) exist(s)');
				return true;
			} else {
				return false;
			}
		},
		async checkSalesDate() {
			if (this.mode == 'add' && this.invoice.so_date != today()) {
				return confirm('Sales date is not today. Continue?');
			} else {
				return true;
			}
		},
		async checkPartnerExists(code) {
			const { data } = await apiCheckPartnerExists({ comparison: 'code', code: code });
			return data.result;
		},
		async checkValidity() {
			if (!this.invoice.so_date) {
				this.$toast.error('Empty Sales Date');
				return false;
			}

			if (!this.invoice.ship_to_code) {
				this.$toast.error('Empty Ship To Code');
				return false;
			}

			if (!this.invoice.bill_to_code) {
				this.$toast.error('Empty Bill To Code');
				return false;
			}

			if (!this.invoice.sales_group_code) {
				this.$toast.error('Empty Sales Group');
				return false;
			}

			if ((this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') && !this.invoice.salesman_id) {
				this.$toast.error('Empty Salesman');
				return false;
			}

			if (!(await this.checkPartnerExists(this.invoice.ship_to_code))) {
				this.$toast.error('Ship To Code of "' + this.invoice.ship_to_code + '" Not Found');
				return false;
			}

			if (!(await this.checkPartnerExists(this.invoice.bill_to_code))) {
				this.$toast.error('Bill To Code of "' + this.invoice.bill_to_code + '" Not Found');
				return false;
			}

			// if (this.invoice.invoice_type == 'R') {
			// 	var b_check = true;
			// 	this.items.forEach(i => {
			// 		var s_quantity = i.return_s_quantity ? i.return_s_quantity : 0;
			// 		var r_quantity = i.return_r_quantity ? i.return_r_quantity : 0;
			// 		var x_quantity = i.return_x_quantity ? i.return_x_quantity : 0;
			// 		//console.log(i.quantity_abs, s_quantity + r_quantity + x_quantity);
			// 		if (i.quantity_abs != s_quantity + r_quantity + x_quantity ) {
			// 			this.$toast.error('Check damange quantities');
			// 			b_check = false;
			// 		}
			// 	});
			// 	if (!b_check) return false;
			// }

			if (this.additionalSO && !this.invoice.main_invoice_no) {
				this.$toast.error('Master SO is not selected');
				return false;
			}

			//if (this.mode == 'add') {
			var credit_limit_to_check;
			if (this.user.company_id == 'newjigu') credit_limit_to_check = this.invoice.total_request_amount;
			else credit_limit_to_check = this.invoice.total_valid_amount;

			//console.log(credit_limit_to_check, this.invoice.ship_to_total_credit_limit);

			if (this.invoice.ship_to_total_credit_limit && credit_limit_to_check + this.total_current_credit > this.invoice.ship_to_total_credit_limit) {
				this.$toast.error('Exceeds credit limit');
				return false;
			} else if (this.invoice.ship_to_credit_limit && credit_limit_to_check + this.current_credit > this.invoice.ship_to_credit_limit) {
				this.$toast.warning('Exceeds monthly credit limit');
			} else if (this.grand_over > 0) {
				//this.$toast.warning('Exceeds monthly credit limit');
				this.$alertify.alert('Alert', 'AR over 60 days exists.');
			}

			if (this.mode == 'detail') {
				var invoiceToSubmit = await this.selectInvoiceForSave();

				if (!invoiceToSubmit) {
					this.$toast.error('Not found');
					return false;
				}

				//console.log(invoiceToSubmit.status_code, this.invoice.org_status_code);
				if (invoiceToSubmit.status_code != this.invoice.org_status_code) {
					this.$toast.error('SO status changed by someone. Please reload the page');
					return false;
				}
			}

			//if (this.user.company_id == 'newjigu' && (this.mode == 'add' || this.invoice.status_code == 'O' || this.invoice.status_code == 'H') && item.unit_price != item.b_price) return 'red';
			if (this.user.company_id == 'newjigu' && (this.mode == 'add' || this.invoice.status_code == 'O' || this.invoice.status_code == 'H') && this.items.filter(item => item.unit_price != item.b_price).length > 0) {
				//alert('Item(s) with odd price exist. Please check');
				this.$toast.error('Item(s) with odd price exist. Please check');
			} else if (
				(this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') &&
				(this.mode == 'add' || this.invoice.status_code == 'O' || this.invoice.status_code == 'H') &&
				this.items.filter(item => item.unit_price != item.min_price).length > 0
			) {
				//alert('Item(s) with odd price exist. Please check');
				this.$toast.error('Item(s) with odd price exist. Please check');
			}

			//}

			//console.log('test3');
			//return false;

			return true;
		},
		checkAutoApprovalPrice() {
			var auto_approval_price = true;
			//if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') {
			if (this.user.company_id == 'beautyplus') {
				//모든 가격이 s_price ~ min_price 사이인지
				this.items.forEach(i => {
					if (i.r_price > 0 && i.r_price < i.s_price) {
						auto_approval_price = false;
					} else if (i.unit_price > 0 && i.s_price > 0 && i.unit_price < i.s_price) {
						auto_approval_price = false;
					}
				});
			}

			return auto_approval_price;
		},
		checkAutoApproval() {
			var reasons = [];
			var auto_approved = true;
			//if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplusplus') {
			if (this.user.company_id == 'beautyplus') {
				if (this.invoice.partner_blocked) {
					reasons.push('Blocked');
					auto_approved = false;
				}

				if (this.invoice.ar_days > 70) {
					reasons.push('AR');
					auto_approved = false;
				}

				this.setDesignation();
				if (this.invoice.designated || this.items.filter(i => i.designated).length > 0) {
					reasons.push('Designated');
					auto_approved = false;
				}
				if (this.invoice.ship_to_address.address_country != 'US') {
					reasons.push('Non-US');
					auto_approved = false;
				}
				if (!this.checkAutoApprovalPrice()) {
					reasons.push('Price');
					auto_approved = false;
				}
				if (this.items.filter(i => i.color_code.toUpperCase() == 'MQ').length > 0) {
					reasons.push('MQ');
					auto_approved = false;
				}
				if (!(this.invoice.total_amount >= 700)) {
					reasons.push('Amount');
					auto_approved = false;
				}
			} else {
				auto_approved = false;
			}

			this.invoice.set_auto_approval = true;
			this.invoice.auto_approved = auto_approved;
			this.invoice.pre_approval_reason = reasons.join(', ');
		},
		async unHold(stay) {
			if (await this.checkValidity()) {
				this.invoice.status_code = this.getPreviousNonHoldStatusCode();
				if (!this.invoice.status_code) this.invoice.status_code = 'O';
				await this.submit(stay, true);
				/*if (!(await this.checkInactiveItemExists())) {
					//this.invoice.status_code = 'O';
					this.invoice.status_code = this.getPreviousNonHoldStatusCode();
					if (!this.invoice.status_code) this.invoice.status_code = 'O';
					await this.submit(stay, true);
				} */
			}
		},
		async revive(stay) {
			if (await this.checkValidity()) {
				this.invoice.status_code = this.getPreviousNonVoidStatusCode();
				if (!this.invoice.status_code) this.invoice.status_code = 'O';
				await this.submit(stay, true);
				/* if (!(await this.checkInactiveItemExists())) {
					//this.invoice.status_code = 'O';
					this.invoice.status_code = this.getPreviousNonVoidStatusCode();
					if (!this.invoice.status_code) this.invoice.status_code = 'O';
					await this.submit(stay, true);
				} */
			}
		},
		async makeVoid(stay) {
			if (confirm('Are you sure to Void this Sales Order?')) {
				if (this.invoice.status_code == 'P' || this.invoice.status_code == 'W') {
					this.$alertify.alert('Alert', 'Immediately inform to the warehouse manager that the order was voided.');
				}

				if (await this.checkValidity()) {
					this.invoice.status_code = 'V';
					delete this.invoice.set_auto_approval;
					await this.submit(stay, true);
				}
			}
		},
		async approve(stay) {
			if (this.user.company_id == 'beautyplus') {
				this.$toast.error('Approval can be done in "Approved Price" Menu');
				return;
			}

			if (this.invoice.partner_blocked || this.partner.blocked) {
				this.$toast.error('Blocked Customer');
				return;
			}

			if (await this.checkValidity()) {
				this.invoice.status_code = 'A';
				this.invoice.approval_timestamp = true;
				await this.submit(stay, true);
			}
		},
		async confirm(stay) {
			if (await this.checkValidity()) {
				this.invoice.status_code = 'C';
				this.invoice.approval_timestamp = true;
				await this.submit(stay, true);
			}
		},
		async hold(stay) {
			if (await this.checkValidity()) {
				this.invoice.status_code = 'H';
				delete this.invoice.set_auto_approval;
				await this.submit(stay, true);
			}
		},
		async packedHold(stay) {
			if (await this.checkValidity()) {
				this.invoice.status_code = 'PH';
				delete this.invoice.set_auto_approval;
				await this.submit(stay, true);
			}
		},
		async packedRevive(stay) {
			if (await this.checkValidity()) {
				this.invoice.status_code = 'W';
				await this.submit(stay, true);
			}
		},
		async cancelApproval(stay) {
			if (await this.checkValidity()) {
				this.invoice.status_code = 'O';
				if (this.invoice.auto_approved) this.invoice.cancel_auto_approval = true;

				delete this.invoice.set_auto_approval;
				await this.submit(stay, true);
			}
		},
		async cancelConfirm(stay) {
			if (await this.checkValidity()) {
				this.invoice.status_code = 'O';
				await this.submit(stay, true);
			}
		},
		async save(stay) {
			// if (this.invoice.status_code == 'A' && (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') && !this.checkAutoApprovalPrice()) {
			// 	this.$toast.error('Violation of approval price condition');
			// 	return false;
			// }

			//if (this.invoice.invoice_type == 'S' && (this.invoice.status_code == 'O' || this.invoice.status_code == 'A')) {
			if (this.invoice.invoice_type == 'S' && (this.invoice.status_code == 'O' || this.mode == 'add')) {
				if (this.confirm_pre_approval) {
					this.invoice.set_auto_approval = true;
					this.invoice.update_history = true;
				} else {
					delete this.invoice.set_auto_approval;
				}
			}

			if (await this.checkValidity()) {
				if (this.mode == 'detail' || !(await this.checkInactiveItemExists())) {
					if (await this.checkSalesDate()) await this.submit(stay, false);
				}
			}
		},
		cancel() {
			//var toGoUri = '';
			//if (this.backUri.indexOf('?') >= 0) toGoUri = this.backUri + '&initial_invoice_type=' + this.invoice.invoice_type;
			//else toGoUri + this.backUri + '?initial_invoice_type=' + this.invoice.invoice_type;
			//console.log(toGoUri);
			this.$router.push(this.backUri);
			//this.$router.push(this.backUri + this.backUri.indexOf('?') >= 0 ? '&' : '?' + 'initial_invoice_type=' + this.invoice.invoice_type);
			//this.$router.push({ name: 'itemMaster', params: {}, query: { backUri: this.$route.fullPath, keyword: item.item_id } });
		},
		async selectInvoiceForSave() {
			const { data } = await apiSelectInvoice({
				so_dn: this.invoice.so_dn,
			});

			return data.invoice;
		},
		setDesignation() {
			const check_items = this.items.filter(i => !i.name.toUpperCase().includes('SAMPLE BOARD') && !i.name.toUpperCase().includes('BANNER'));
			//if (this.items.length > 0 && this.items.filter(i => i.designated).length == this.items.length) {
			if (check_items.length > 0 && check_items.filter(i => i.designated).length == check_items.length) {
				this.invoice.designated = 1;
				//if (this.user.company_id == 'beautyplus' && !this.invoice.remark) this.invoice.remark = '즉시수금 30일';
			} else {
				this.invoice.designated = 0;
				//if (this.user.company_id == 'beautyplus' && this.invoice.remark == '즉시수금 30일') this.invoice.remark = null;
			}
		},
		async submit(stay, status_changed) {
			if (this.invoice.ship_to_code != this.invoice.bill_to_code) {
				alert('Bill To is different from Ship To. Please Check!!!');
			}

			if (this.to_check_items.length > 0 && this.user.company_id != 'beautyplus' && this.user.company_id != 'hairplus') {
				var msg = 'Please Check Item(s) Order Quantity\n\n';
				this.to_check_items.forEach(i => {
					msg += i.item_code + ' : ' + i.quantity + '\n';
				});
				alert(msg);
				//console.log(this.to_check_items);
			}
			// if (this.mode == 'detail') {
			// 	var invoiceToSubmit = await this.selectInvoiceForSave();

			// 	if (!invoiceToSubmit) {
			// 		this.$toast.error('Not found');
			// 		return;
			// 	}

			// 	if (invoiceToSubmit.status_code != this.invoice.org_status_code) {
			// 		this.$toast.error('SO status changed by someone. Please reload the page');
			// 		return;
			// 	}
			// }

			//console.log(this.items);
			this.invoice.items = this.items;
			this.invoice.item_nos_to_delete = this.item_nos_to_delete;

			//if (this.invoice.status_code == 'O' || this.mode == 'add') this.setDesignation();

			//아래 사용 안됨
			/*
			var bo_invoice_item_nos = [];
			this.items.forEach(i => {
				if (i.bo_invoice_item_no) bo_invoice_item_nos.push(i.bo_invoice_item_no);
			});
			this.invoice.bo_invoice_item_nos = bo_invoice_item_nos;
			*/

			if (!this.additionalSO) this.invoice.main_invoice_no = null;

			//console.log(this.invoice);
			//console.log(this.items);
			//const dummy = true;
			//f (dummy) return;
			//console.log(isMobile);

			var response;
			if (this.mode == 'add') {
				this.invoice.source = isMobile ? 'MOBILE WEB' : 'PC WEB';
				// if (this.invoice.invoice_type == 'S' && this.checkAutoApproval()) {
				// 	this.invoice.auto_approval = true;
				// }

				response = await apiInsertInvoice(this.invoice);
			} else {
				response = await apiUpdateInvoice(this.invoice, status_changed);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');

				if (!status_changed && this.invoice.status_code == 'P') {
					this.$alertify.alert('Alert', 'If the order has been changed, please notify the warehouse people.');
				}

				//console.log(this.backUri);
				if (!stay) {
					this.$router.push(this.backUri);
					//this.$router.push(this.backUri + '&initial_invoice_type=' + this.invoice.invoice_type);
					//var toGoUri = '';
					//console.log(this.backUri);
					//if (this.backUri.indexOf('?') >= 0) toGoUri = this.backUri + '&initial_invoice_type=' + this.invoice.invoice_type;
					//else toGoUri + '?initial_invoice_type=' + this.invoice.invoice_type;
					//console.log(toGoUri);
					//this.$router.push(toGoUri);
					//this.$router.push(this.backUri + this.backUri.indexOf('?') >= 0 ? '&' : '?' + 'initial_invoice_type=' + this.invoice.invoice_type);
				} else {
					if (this.mode == 'add') {
						this.invoice.invoice_no = data.invoice_no;
						this.invoice.so_dn = data.so_dn;

						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Sales Order -> Detail');
					}
					await this.selectInvoice();
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateRemarks() {
			const { data } = await apiUpdateRemarks(this.invoice);
			if (data.result) {
				this.$toast.success('Saved successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateSalesGroup() {
			const { data } = await apiUpdateSalesGroup(this.invoice);
			if (data.result) {
				this.$toast.success('Saved successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateSalesMan() {
			const { data } = await apiUpdateSalesMan(this.invoice);
			if (data.result) {
				this.$toast.success('Saved successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		addNew() {
			this.mode = 'add';
			this.$store.commit('setSubTitle', 'Sales Order -> Add');
			this.sale_only = false;
			this.return_only = false;
			this.invoice = {
				invoice_type: this.invoice.invoice_type,
				so_dn: null,
				restock_fee: 0,
				other_charge: 0,

				auto_approved: false,
				pre_approval_reason: null,

				payment_term_code: null,
				ship_charge_code: null,
				delivery_type_code: null,

				ship_to_address: {},
			};
			this.prev_ship_to_address_list = [];
			this.partner = {};
			this.histories = [];
			this.popup_items = [];
			this.items = [];
			this.item_nos_to_delete = [];
			this.prevInvoices = [];
			this.prevInvoicesCount = 0;
			this.prevInvoicesBalanceSum = 0;
			this.postChecks = [];
			this.prevInvoice = {};
			this.callTag = {};
			this.shipToAddresses = [];
			this.additionalSO = false;
			this.allSelected = false;
			this.allPreviousItemsSelected = false;
			this.itemClass = null;
			this.className = null;
			this.keyword = '';
			this.searchItems = [];

			this.toReceiveInvoices = [];
			this.pay_amount = null;
			this.current_credit = 0;
			this.total_current_credit = 0;

			this.modalName = '';
			this.prevModalName = '';
			this.showModal = false;

			this.tval = 1.45;
			this.locationNameObjList = '';
			this.labelShowModal = false;
			this.invoicePrintData = '';
			this.locationList = '';

			this.confirm_pre_approval = false;

			this.to_check_items = [];

			if (this.profile.use_temp_flag == 'Y') {
				this.invoice.temp_flag = true;
				this.$forceUpdate();
			}

			var uri = '/sales/so/add?backUri=' + this.backUri;
			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);

			this.invoice.so_date = today();
			this.page_no = 1;
			this.$refs.paging.setPage(this.page_no, this.page_size, this.prevInvoicesCount);

			this.$forceUpdate();
			this.$refs.shipto.$el.children[0].focus();
		},
		async printPickingTicket(copy) {
			try {
				const { data } = await apiPickingPrintDataList(objectToFormData({ invoiceNos: this.invoice.invoice_no }));
				if (copy) data.data[0].copy = copy;

				const reportTemplate = await apiGetReportTemplate('Picking', companyMrtUrl('Picking'));
				const report = new Report(reportTemplate, data.data[0], 'Picking', PrintType.Normal);
				this.$store.commit('setReport', report);
				await apiPrintPickingTicket(this.invoice);
				await this.selectInvoice();
				this.$toast.success('Picking Ticket Printed Successfully');
			} catch (error) {
				this.$toast.error('Picking Ticket error');
			}
		},
		async unitTicketModal() {
			this.labelShowModal = true;
		},
		async unitTicketPrint() {
			const list = [];
			this.locationCountList.forEach(value => {
				for (let i = 0; i < value.count; i++) {
					list.push(value.name);
				}
			});
			const { data } = await apiPickingPrintDataList(objectToFormData({ invoiceNos: this.invoice.invoice_no }));
			const invoice = data.data[0];
			invoice.unitLabelList = list;
			const reportTemplate = await apiGetBase64ReportTemplate('UnitBoxTicket', companyMrtUrl('UnitBoxTicket'));
			const report = new Report(reportTemplate, invoice, 'UnitBoxTicket', PrintType.Normal);
			this.labelModal();
			this.$store.commit('setReport', report);
			this.$toast.success('Unit Box Ticket Printed Successfully');
		},
		async wholeTicketPrint() {
			this.$toast.success('Whole Box Ticket Printed Successfully');
			const { data } = await apiPickingPrintDataList(objectToFormData({ invoiceNos: this.invoice.invoice_no }));
			const reportTemplate = await apiGetReportTemplate('WholeBoxTicket', companyMrtUrl('WholeBoxTicket'));
			const report = new Report(reportTemplate, data.data[0], 'WholeBoxTicket', PrintType.Normal);
			this.$store.commit('setReport', report);
		},
		viewHistory() {
			this.prevModalName = '';
			this.openModal('History');

			//console.log(this.histories);
		},
		getPreviousNonVoidStatusCode() {
			var prevStatusCode = null;
			for (var i = this.histories.length - 1; i >= 0; i--) {
				if (this.histories[i].status_code != 'V') {
					prevStatusCode = this.histories[i].status_code;
					break;
				}
			}

			return prevStatusCode;
		},
		getPreviousNonHoldStatusCode() {
			var prevStatusCode = null;
			for (var i = this.histories.length - 1; i >= 0; i--) {
				if (this.histories[i].status_code != 'H' && this.histories[i].status_code != 'V') {
					prevStatusCode = this.histories[i].status_code;
					break;
				}
			}

			return prevStatusCode;
		},
		openMemo(partner_code) {
			this.partner_code_for_memo = partner_code;
			this.openModal('Memo');
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal(focusToAc) {
			if (this.modalName == 'ItemSelect') {
				this.keyword = '';
				this.itemClass = null;
				this.className = null;
			}

			this.showModal = false;

			if (focusToAc) this.$refs.ac.$el.children[0].children[1].children[0].focus();
		},
		labelModal() {
			this.labelShowModal = false;
		},
		closeDoubleModal() {
			//this.modalName = 'History';
			this.modalName = this.prevModalName;
		},
		closePromotionModal() {
			if (this.modalName == 'Memo&Promotion') {
				this.modalName = 'Memo';
			} else {
				this.closeModal();
			}
		},
		addItems(items) {
			//console.log(items);
			//var vm = this;
			//items.forEach(item => (item.unit_price = item.net_price));
			var to_add_items = [];
			items.forEach(function(item) {
				item.quantity_abs = item.quantity;
				item.unit_price = item.net_price;
				item.last_price = item.last_net_price;
				//vm.items.push(item);
				to_add_items.push(item);
			});

			this.mergeItems(to_add_items);

			this.reset();

			//console.log(items);
		},
		async index() {
			const { data } = await apiSoIndex();

			this.paymentTerms = data.paymentTermList;
			this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.deliveryTypes = data.deliveryTypeList;
			this.returnTypes = data.returnTypeList;
			this.remarks = data.remarkList;
			this.specialSales = data.specialSaleList;
			this.locationList = data.locationList;
		},
		async selectTempInvoice() {
			var param = {
				temp_invoice_no: this.invoice.temp_invoice_no,
			};
			if (this.user.company_id == 'newjigu' || this.user.company_id == 'hairplus') param.include_specialty = true;
			const { data } = await apiSelectTempInvoice(param);
			//console.log(data);

			this.invoice = _.cloneDeep(data.tempInvoice);

			this.items = data.tempInvoiceItemList;
			this.partner = data.partner;
			this.setSpecialty(this.partner);
			this.bill_partner = data.bill_partner;
			this.setSpecialty(this.bill_partner);

			if (this.partner) this.setShipTo(this.partner, true);

			this.invoice.ship_to_address = {
				ship_to_name: data.tempInvoice.address_ship_to_name,
				address_detail: data.tempInvoice.address_detail,
				address_detail2: data.tempInvoice.address_detail2,
				address_city: data.tempInvoice.address_city,
				address_state: data.tempInvoice.address_state,
				address_zipcode: data.tempInvoice.address_zipcode,
				address_country: data.tempInvoice.address_country,
				telephone: data.tempInvoice.telephone,
			};
			//console.log(this.invoice.ship_to_address);

			this.ship_to_address = this.invoice.ship_to_address;
			//console.log(this.items);
		},
		async init() {
			await this.index();
			this.saleStatusCodes = this.$saleStatusCodes;

			var response;

			if (this.mode == 'detail') {
				await this.selectInvoice();
			} else if (this.mode == 'add' && this.$route.query.all_return) {
				this.return_only = true;
				this.invoice.invoice_type = 'R';

				const { data } = await apiSelectInvoice({ invoice_no: this.$route.query.org_invoice_no, include_partner: true });
				//console.log(data);

				this.invoice.sales_group_code = data.invoice.sales_group_code;
				this.invoice.ship_to_code = data.invoice.ship_to_code;
				this.invoice.bill_to_code = data.invoice.bill_to_code;
				this.invoice.other_charge = -1 * data.invoice.total_charge;

				this.partner = data.partner;
				this.bill_partner = data.bill_partner;

				this.items = [];
				data.invoiceItemList.forEach(i => {
					var new_item = _.cloneDeep(i);
					new_item.invoice_item_no = null;
					new_item.quantity_abs = i.shipped_quantity_abs;
					new_item.shipped_quantity = null;

					new_item.unit_price = i.unit_price;
					this.items.push(new_item);
				});

				//console.log(this.items);
				//} else if (this.mode == 'add' && this.invoice.temp_invoice_no > 0) {
			} else if (this.mode == 'add' && this.init_from_temp) {
				await this.selectTempInvoice();
			} else if (this.mode == 'add' && (this.$route.query.initial_ship_to_code || this.$route.query.ship_to_code)) {
				if (this.$route.query.ship_to_code) {
					this.sale_only = true;
					this.invoice.ship_to_code = this.$route.query.ship_to_code;
				} else {
					this.invoice.ship_to_code = this.$route.query.initial_ship_to_code;
					this.$alertify.alert('Ship To Code', 'Ship to code was set : ' + this.invoice.ship_to_code);
				}

				var param = { code: this.invoice.ship_to_code };
				if (this.user.company_id == 'newjigu' || this.user.company_id == 'hairplus') param.include_specialty = true;

				response = await apiSelectPartner(param);

				if (response.data.partner) {
					this.setShipTo(response.data.partner);
				}

				if (this.$route.query.ship_to_code) {
					param = {
						paging_yn: 'N',
						invoice_item_nos: this.$route.query.invoice_item_nos.split(','),
					};
					response = await apiSelectBackOrderItemList(param);

					this.items = [];
					var vm = this;
					response.data.itemList.forEach(i => {
						var new_item = _.cloneDeep(i);
						new_item.bo_invoice_item_no = i.invoice_item_no; //사용 안되는 것 같음..일단 그대로.
						new_item.invoice_item_no = null;
						new_item.quantity_abs = i.bo_quantity;
						new_item.shipped_quantity = null;

						new_item.unit_price = i.min_price;
						new_item.last_price = i.last_price;
						new_item.last_net_price = i.last_price;
						new_item.r_price = i.unit_price;

						var foundItems = vm.items.filter(i => i.item_id == new_item.item_id);
						if (foundItems.length > 0) foundItems[0].quantity_abs += new_item.quantity_abs;
						else this.items.push(new_item);
					});
				}
			} else if (this.mode == 'add' && this.$route.query.call_tag_no) {
				this.return_only = true;
				this.invoice.invoice_type = 'R';
				this.invoice.call_tag_no = this.$route.query.call_tag_no;

				response = await apiSelectCallTag({
					call_tag_no: this.$route.query.call_tag_no,
				});
				//console.log(response.data);
				if (response.data.call_tag.weights) {
					this.invoice.call_tag_box_count = response.data.call_tag.weights.split('|').length;
					this.invoice.box_count = response.data.call_tag.weights.split('|').length;
				} else {
					this.invoice.call_tag_box_count = 0;
					this.invoice.box_count = 0;
				}
				this.invoice.call_tag_dn = response.data.call_tag.call_tag_dn;
				this.invoice.ship_to_code = response.data.call_tag.ship_to_code;

				param = { code: this.invoice.ship_to_code };
				if (this.user.company_id == 'newjigu' || this.user.company_id == 'hairplus') param.include_specialty = true;
				response = await apiSelectPartner(param);

				if (response.data.partner) {
					this.setShipTo(response.data.partner);
				}

				// const { data } = await apiSelectInvoice({
				// 	invoice_no: this.$route.query.invoice_no,
				// });
				// this.setInvoice(data.invoice);
			}

			if (this.mode == 'add' && this.profile.use_temp_flag == 'Y') {
				this.invoice.temp_flag = true;
				this.$forceUpdate();
			}

			inputSelectOnClick();
		},
		// async test() {
		// 	const { data } = await apiInsertInvoice(this.invoice);

		// 	if (data.result) {
		// 		this.$toast.success('Saved successfully');
		// 	} else {
		// 		this.$toast.error(data.msg);
		// 	}
		// },
		async updateSalesOrderPrint(invoice_no) {
			const { status } = await apiUpdateSalesOrderPrint(invoice_no);
			if (status !== 200) {
				this.$toast.error('Network Error');
				return;
			}
		},
		async salesOrder() {
			// await this.$alertify.confirm(
			// 	'Do you want to Label print?',
			// 	() => this.salesOrderPrint('Y'),
			// 	() => this.salesOrderPrint('N'),
			// );

			await this.salesOrderPrint('N');
		},
		async salesOrderPrint(type) {
			const { data } = await apiInvoicePrintData(this.invoice.invoice_no);
			// console.log(data);
			// S/O Print 정보 Update
			if (!data.invoice.so_print_dt) this.updateSalesOrderPrint(data.invoice.invoice_no);

			const reportTemplate = await apiGetReportTemplate('SalesOrder', companyMrtUrl('SalesOrder'));
			data.invoice.commentPrint = type;
			let toList = this.invoiceAddressList(data.invoice);
			const report = new Report(reportTemplate, data, this.invoice.bill_to_code, undefined, false, false, toList);
			this.$store.commit('setReport', report);
		},
		invoiceAddressList(invoice) {
			let toList = [];
			let shipPartner = invoice.ship_partner;
			let billPartner = invoice.bill_partner;
			shipPartner.email;
			if (shipPartner.email) toList.push(shipPartner.email);
			if (!toList.includes(shipPartner.email2) && shipPartner.email2) toList.push(shipPartner.email2);
			if (!toList.includes(billPartner.email) && billPartner.email) toList.push(billPartner.email);
			if (!toList.includes(billPartner.email2) && billPartner.email2) toList.push(billPartner.email2);
			return toList;
		},

		async returnSalesOrder() {
			//console.log('aaa');
			//const { data } = await apiInvoicePrintData(this.invoice.invoice_no);
			var include_sales_count = 'N';
			if (this.user.company_id == 'beautyplus') include_sales_count = 'Y';

			const { data } = await apiReturnInvoicePrintData(this.invoice.invoice_no, include_sales_count);

			// S/O Print 정보 Update
			if (!data.invoice.so_print_dt) this.updateSalesOrderPrint(data.invoice.invoice_no);
			let toList = this.invoiceAddressList(data.invoice);
			const reportTemplate = await apiGetReportTemplate('ReturnSales', companyMrtUrl('ReturnSales'));
			const report = new Report(reportTemplate, data, 'ReturnSales', undefined, false, false, toList);
			this.$store.commit('setReport', report);
		},
		async proFormaTempInvoicePrint() {
			const { data } = await apiTempInvoicePrintData(this.invoice.temp_invoice_no);
			if (data && data.invoice && data.invoice.invoice_items) {
				let total_request_amount = 0;
				data.invoice.invoice_items.forEach(item => {
					// newjigu의 경우 r_price가 없거나 0이어도 min_price로 값을 대신하지 않음.
					if (this.user && this.user.company_id !== 'newjigu') {
						item.r_price = item.r_price > 0 ? item.r_price : item.unit_price;
					} else if (this.user && this.user.company_id === 'newjigu') {
						item.price_used = item.r_price != 0 && !item.r_price ? item.unit_price : item.r_price;
					}

					var effective_price = item.r_price > 0 ? item.r_price : item.min_price > 0 ? item.min_price : 0;
					var effective_quantity = 0;

					if (this.user.company_id === 'beautyplus') effective_quantity = item.quantity < item.on_hand ? item.quantity : item.on_hand;
					else effective_quantity = item.available_quantity > item.quantity ? item.quantity : item.available_quantity > 0 ? item.available_quantity : 0;

					if (effective_quantity > 0) total_request_amount += effective_quantity * effective_price;
				});

				data.invoice.total_request_amount = total_request_amount;
			}
			const reportTemplate = await apiGetReportTemplate('ProFormaInvoice', companyMrtUrl('TempProFormaInvoice'));
			const report = new Report(reportTemplate, data, this.invoice.bill_to_code);
			this.$store.commit('setReport', report);
		},
		async getInvoiceItemList(invoice_no) {
			const { data } = await apiSelectInvoiceItemList({ invoice_no });
			return data.invoiceItemList;
		},
		async proFormaInvoicePrint() {
			const { data } = await apiInvoicePrintData(this.invoice.invoice_no);

			if (data && data.invoice && data.invoice.invoice_items) {
				if (this.user && this.user.company_id === 'newjigu') {
					// newjigu의 경우 r_price가 없거나 0이어도 min_price로 값을 대신하지 않음.
					// Service단의 selectInvoicePrint메서드는 범용적으로 사용되기 때문에 View단에서 수정함.
					const ori_item_list = await this.getInvoiceItemList(this.invoice.invoice_no);
					data.invoice.invoice_items.forEach(it => {
						const idx = ori_item_list.findIndex(ori => ori.invoice_item_no === it.invoice_item_no);
						if (idx > -1) it.r_price = ori_item_list[idx].r_price;

						if (!data.invoice.approval_dt) it.price_used = it.r_price != 0 && !it.r_price ? it.unit_price : it.r_price;
						else it.price_used = it.unit_price;
					});
				}

				let total_request_amount = 0;
				data.invoice.invoice_items.forEach(item => {
					var effective_price = item.r_price > 0 ? item.r_price : item.min_price > 0 ? item.min_price : 0;
					var effective_quantity = 0;

					if (this.user.company_id === 'beautyplus') effective_quantity = item.quantity < item.on_hand ? item.quantity : item.on_hand;
					else effective_quantity = item.available_quantity > item.quantity ? item.quantity : item.available_quantity > 0 ? item.available_quantity : 0;

					if (effective_quantity > 0) total_request_amount += effective_quantity * effective_price;
				});

				data.invoice.total_request_amount = total_request_amount;
			}

			// console.log(JSON.stringify(data.invoice.invoice_items, null, 4));

			const reportTemplate = await apiGetReportTemplate('ProFormaInvoice', companyMrtUrl('ProFormaInvoice'));
			const report = new Report(reportTemplate, data, this.invoice.bill_to_code);
			this.$store.commit('setReport', report);
		},

		// packingPrintHistoryModalAction() {
		// 	this.$refs.packingPrintHistoryModal.action();
		// },
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_so_main');

		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Sales Order -> Add');

			if (this.$route.params.temp_invoice_no > 0) {
				//console.log('temp invoice');
				this.init_from_temp = true;
				this.invoice.temp_invoice_no = this.$route.params.temp_invoice_no;
			} else {
				this.invoice.so_date = today();
				if (this.$route.query.initial_invoice_type) this.invoice.invoice_type = this.$route.query.initial_invoice_type;
			}
		} else {
			this.$store.commit('setSubTitle', 'Sales Order -> Detail');
			this.invoice.invoice_no = this.$route.query.invoice_no;

			if (!this.invoice.invoice_no) {
				//console.log('empty...', this.backUri);
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		inputSelectOnClick();
		// $(this.$refs.invoice_items).floatThead({ zIndex: 1, autoReflow: true });

		if (this.mode == 'add' && !this.$route.query.all_return && !this.$route.query.initial_ship_to_code && !this.$route.query.ship_to_code && !(this.invoice.temp_invoice_no > 0)) {
			//console.log(this.invoice.ship_to_code);
			this.$nextTick(function() {
				//console.log(this.$refs.shipto.$el.children[0]);
				//console.log(this.$refs.remark1);
				this.$refs.shipto.$el.children[0].focus();
				//this.$refs.remark1.focus();
				//@focus="$event.target.select()"

				// if (this.invoice.invoice_type == 'R') {
				// 	this.invoice.restock_fee = 0;
				// 	this.invoice.other_charge = 0;
				// }
			});
		}
	},
};
</script>

<style>
td a:hover {
	text-decoration: underline;
	color: #ff0000;
}

.remark-table {
	border: 1px solid lightgray;
	padding-right: 2px;
}

.view_tbl3 {
	width: 100%;
}
.view_tbl3 tbody th {
	font-size: 12px;
	color: #222;
	text-align: right;
}
.view_tbl3 tbody .top_th {
	padding: 4px 0px;
	vertical-align: top;
	line-height: 24px;
}
.view_tbl3 tbody td {
	padding: 1px 2px;
}

.remark_int {
	border: 0;
	height: 22px;
	width: 100%;
	font-size: 12px;
	padding: 0 4px 0 4px;
}
</style>
